import { Model, FunctionFactory } from "survey-core";
import { ReactSurveyElementsWrapper, Survey } from "survey-react-ui";
import { useCallback, useEffect, useState, useRef, createRef } from "react";
import { useApolloClient, useQuery } from "@apollo/client";
import GetSurvey, { GetSurveyResponses } from "../queries/GetSurvey";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ComponentCollection, Serializer } from "survey-core";
import moment from "moment";
import "survey-core/defaultV2.min.css";
import "./CustomSurvey.scss";
import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Stack,
  Typography,
} from "@mui/material";
import ComeBackLater from "../components/ComeBackLater";
import axios from "axios";
import {
  defaultTheme,
  skodaTheme,
  rotatryTheme,
  lifecellTheme,
  blackOrchidTheme,
  zimsonTheme,
  saiBabaTheme,
  AMJTheme,
  ExpoTheme,
  SaravanaTheme,
} from "../surveyThemes/themes";
import ThankYouPage from "../components/ThankyouPage";
import { getAPI } from "../api/getApi";
import RedirectDailog from "../components/RedirectDialog";
import { citiesInIndia } from "../common/city";
import { state } from "../common/state";
import { Designations, department } from "../common/department";
import { industry } from "../common/industry";
import { merchantCreation } from "../common/merchantCreation";
import { getValue } from "@testing-library/user-event/dist/utils";
import { decodeJWT } from "./UrlToken";
import branchCreation from "../common/branchCreation";
import contactCreation from "../common/contactCreation";
import Pincodevar from "../common/Pincodevar";
import axiosGet from "../api/axiosGet";
import CloseIcon from "@mui/icons-material/Close";
import {
  ApiFunction,
  CrmActivityCreate,
  GetCNGCardsDetails,
  GetECCardsDetails,
  GetEcUserDetails,
  GetLPGardsDetails,
  GetSurveyDetails,
  InsertCNGLeads,
  create_product,
  decodeUserData,
  flattenArray,
  getFreeFillForm,
  getOTP,
  gogasCNGUsers,
  gogasCNGWalletTrans,
  gogasCoinAdding,
  gogasCoinsRedeem,
  gogasLocation,
  onUploadName,
  send_coins,
  setInitalHeaders,
} from "../common/methods";
import { encode } from "@yag/id-hash";
import { registerCounter } from "../components/Counter";
import { registerSearchDropdown } from "../components/SearchDropdown";
import LogoutIcon from "@mui/icons-material/Logout";
import UseCRMToken from "../queries/GetCrmTokens";
import { registerQrScanner } from "../components/QrScanner";
import { registerCouponsInput } from "../components/CouponInput";
import { registerCamera } from "../components/CameraQuestion";
import { getBalanceQuery } from "../queries/GetBalance";
import { client } from "..";
import { getGamesResQuery } from "../queries/GetGamesResponses";
import { CreategogasUser } from "../mutations/CreateGogasUser";
import { UpdateSurveyResponse } from "../mutations/UpdateSurveyRes";
import { UpdateECCards } from "../mutations/UpdateECCards";
import { InsertECUsers } from "../mutations/InsertECUSers";
import { UpdateLPGCards } from "../mutations/UpdateLPGCards";
import { assignCardToUser } from "../mutations/UpdateEcCardsUser";
import { GetSpacesQuery } from "../queries/GetSpaces";
import { InsertGogasReferralReg } from "../mutations/InsertGogasReferralReg";
import { GetGogasUsers } from "../queries/GetGogasUsers";
import { CreateApiUser } from "../mutations/CreateApiUser";
import { GetApexStatesQuery } from "../queries/GetApexStates";
import { GetSurveyResponseCount } from "../queries/GetSurveyResponseCount";
import ContestThankYou from "../components/ContestThankYou";

// slk("MmRiY2U1M2YtNzkxZi00MTAzLThiMjYtMmY1MjM0OTA4OGY2OzE9MjAyNC0wNS0xOQ==");
// custom counter question
registerCounter();
// custom search dropdown question
registerSearchDropdown();
// custom Qr scanner
registerQrScanner();
// custom textbox
registerCouponsInput();
// custom camera
registerCamera();

function CustomSurvey() {
  const [formDetails, SetFormDetails] = useState([]);
  const [coupons, SetCoupons] = useState([]);
  const [tryButton, setTryButton] = useState(false);
  const couponsRef = useRef([]);
  const qrIdRef = useRef(0);
  const surveyIdRef = useRef(0);
  const gogasResRef = useRef({});
  const [formComplete, SetFormComplete] = useState(false);
  const [loading, SetLoading] = useState(true);
  const [alreadyDone, SetAlreadyDone] = useState(false);
  const [banner, SetBanner] = useState("");
  const skodaObj = useRef("");
  const redeemCode = useRef("");
  const accID = useRef("");
  const blackOrchidId = useRef("");
  const loadingRef = useRef(true);
  const already_done = useRef(false);
  const googleRating = useRef("");
  const dataRef = useRef({});
  // const [msgTitle, SetMsgTitle] = useState("");
  const msgTitleRef = useRef("Thank You");
  const statusRef = useRef("");
  const [resultTrue, setResultTrue] = useState(false);
  const msgRef = useRef("Your feedback is valuable to us");
  const metadataRef = useRef("");
  const redirect = useRef(false);
  // const [msg, SetMsg] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  // const history=useHistory()
  if (queryParams.get("token")) {

  }
  const survey2 = new Model(formDetails);
  const token = queryParams.get("utoken") || localStorage.getItem("token");
  const mtoken = queryParams.get("token") || localStorage.getItem("mtoken");
  const acc_id = localStorage.getItem("accid");
  const decode =
    (token &&
      token !== "undefined" &&
      decodeJWT(token)["https://hasura.io/jwt/claims"]["x-hasura-phone"]) ||
    "";
  const accId = queryParams.get("acc_id");
  let acc_data;
  if (acc_id || accId) {
    acc_data = UseCRMToken(acc_id || accId);
    // console.log(acc_data, 'data', acc_id);
    localStorage.setItem("crm_token", acc_data?.token?.directus_token);
    if (acc_data?.token?.space_accounts?.length > 0) {
      survey2.setValue("station_name", acc_data?.token?.space_accounts[0]?.space?.details?.station_name);
      survey2.setValue("city", acc_data?.token?.space_accounts[0]?.space?.details?.city);
      survey2.setValue("state", acc_data?.token?.space_accounts[0]?.space?.details?.state);
      survey2.setValue("cashback", acc_data?.token?.space_accounts[0]?.space?.details?.cashback);
      survey2.setValue("cpil_region", acc_data?.token?.space_accounts[0]?.space?.details?.cpil_region);
      survey2.setValue("erp_code", acc_data?.token?.space_accounts[0]?.space?.details?.erp_code);
      survey2.setValue("scheme", acc_data?.token?.space_accounts[0]?.space?.details?.scheme);
      survey2.setValue("gogas_rsp", acc_data?.token?.space_accounts[0]?.space?.gogas_rsp);
      survey2.setValue("terr_m", acc_data?.token?.space_accounts[0]?.space?.details?.terr_m);
      survey2.setValue("max_cap", acc_data?.token?.space_accounts[0]?.space?.details?.maxCap);
    } else {
      survey2.setValue("station_name", acc_data?.token?.username);
    }
    survey2.setValue("sales_name", acc_data?.token?.username);
    survey2.setValue("sales_mob", acc_data?.token?.phone_number);
    // survey2.setValue("acc_id", acc_data?.token?.cng_accounts_to_extraa_accounts?.id || acc_data?.token?.id);
  }
  // console.log(acc_data,'crmtoken');
  // const client = useApolloClient();
  // console.log(formDetails,'token')
  survey2.clearInvisibleValues = false;

  //urlParamsFunction
  const UrlParams = (parameters) => {
    const params = new URLSearchParams(window.location.search);
    parameters.forEach((item) => {
      //console.log(item);
      survey2.setValue(item, params.get(item));
    });
  };
  const urlParams = new URLSearchParams(window.location.search);
  const dataParam = urlParams.get("data") || queryParams.get("data");
  let decodedUser = null;
  if (dataParam) {
    decodedUser = decodeUserData(dataParam);
    if (decodedUser?.name) {
      survey2.setValue("name", decodedUser.name);
    }
  }

  survey2.setValue("mobile", decodedUser?.mobile || decode || "");
  survey2.setValue("user_id", queryParams.get("user_id") || "");
  const sales_mob = queryParams.get("sales_mob");
  const sales_name = queryParams.get("sales_name");
  // console.log(sales_mob,'val',value);
  const queryList = [];
  // console.log(urlParams, 'urls');

  //set answer from url params
  const answerParams = () => {
    for (const [key, value] of urlParams) {
      if (key !== "data" && key !== "token" && key !== "utoken") {
        queryList.push({ key, value });
      }
    }
    // Now, queryList contains the query parameters in the form of a list of objects
    // console.log(queryList, 'list');
  };
  answerParams();

  if (queryList?.length > 0) {
    // console.log('true')
    queryList?.forEach((e) => {
      survey2.setValue(e?.key, e?.value?.replace(/_/g, " "));
    });
  }

  // pothys sales man survey
  const pothysSalesParams = () => {
    //console.log("dsdas")
    survey2.setValue("sales_name", sales_name?.replace(/_/g, " "));
    survey2.setValue("sales_mob", sales_mob);
    survey2.setValue("sales_emp", urlParams.get("sales_emp"));
    survey2.setValue(
      "sales_floor",
      urlParams.get("sales_floor")?.replace(/_/g, " ")
    );
    const desi = urlParams.get("sales_desi")?.replace(/_/g, " ")
    survey2.setValue(
      "sales_designation",
      desi || urlParams.get("sales_designation")?.replace(/_/g, " ")
    );
  };
  if (urlParams.get("sales_emp") && urlParams.get("sales_emp") !== "") {
    pothysSalesParams();
  }

  if (sales_mob || sales_name) {
    survey2.setValue("mobile", "");
  }
  survey2.setValue(
    "salesname",
    localStorage.getItem("user_name") || sales_name
  );
  survey2.setValue(
    "salesmobile",
    localStorage.getItem("user_ph_number") || sales_mob
  );
  survey2.setValue("account_id", acc_id || accId);
  //hospital
  if (surveyIdRef.current === 193) {
    survey2.clearInvisibleValues = false;
    const parameters = ["city", "hospitalCode", "hospitalName"];
    UrlParams(parameters);
  }
  if (localStorage.getItem("crm_token")) {
    survey2.setValue(
      "crm_token",
      `{Authorization: Bearer ${localStorage.getItem("crm_token")}}`
    );
  }
  //sowbaghya
  // if(surveyIdRef.current===200){
  //   survey2.clearInvisibleValues=false
  //   const parameters=["productCategory","productCode","productDescription"]
  //   UrlParams(parameters);
  // }
  onUploadName(survey2, surveyIdRef.current);
  // survey2.onUploadFiles.add((_, options) => {
  //   const filename = options.files[0].name
  //     .replace(/[^a-zA-Z0-9.]/g, "_")
  //     .replace(/\s+/g, "_");
  //   let formData = new FormData();
  //   formData.append("file", options.files[0], filename);

  //   let config = {
  //     method: "POST",
  //     body: formData,
  //     redirect: "follow",
  //   };

  //   fetch("https://storage.extraa.in/upload", config)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       options.callback(
  //         "success",
  //         options.files.map((file) => {
  //           return {
  //             file: file,
  //             content: data.url,
  //           };
  //         })
  //       );
  //     })
  //     .catch((error) => {
  //       console.error("Error: ", error);
  //     });
  // });

  // function setInitalHeaders() {
  //   if (localStorage.token) {
  //     return {
  //       "Content-Type": "application/json",
  //       authorization: "Bearer " + localStorage.token,
  //     };
  //   }

  //   return {
  //     "Content-Type": "application/json",
  //     authorization:
  //       "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ikd1ZXN0IiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbImd1ZXN0Il0sIngtaGFzdXJhLWRlZmF1bHQtcm9sZSI6Imd1ZXN0In19.dFW-ZzED-qnnoWVb0r9oZIcmn2gSsBxqBp30BuUz1wk",
  //   };
  // }
  //

  // SEND OTP

  let headers = new Headers();

  // function getOTP([mobile], bool) {
  //   loadingRef.current = true;
  //   // console.log("getting");
  //   if (!mobile) {
  //     this.returnResult(false);
  //     return;
  //   }
  //   // SetphNum(num);
  //   // SetLoading(true);
  //   headers.append("Content-Type", "application/json");

  //   let data = bool
  //     ? {
  //       phone_number: mobile,
  //       qr_id: 1,
  //       skoda: true,
  //     }
  //     : {
  //       phone_number: mobile,
  //       qr_id: 1,
  //     };

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: "https://faas-blr1-8177d592.doserverless.co/api/v1/web/fn-5eb492b6-735e-4a32-8582-c80db698fb7e/user/get-otp",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios(config)
  //     .then(function (response) {
  //       //  console.log(response.data);
  //       localStorage.setItem("otp_id", response.data.insert_otp.id);
  //       localStorage.setItem("user_id", response.data.user.id);
  //       // loadingRef.current = false;
  //       this.returnResult(true);
  //       // SetLoading(false);
  //       // navigate("/verify-otp", {
  //       //   state: {
  //       //     otp_id: response.data.insert_otp.id,
  //       //     user_id: response.data.user.id,
  //       //     phone_number: sender.data.mobile,
  //       //   },
  //       // });
  //     })
  //     .catch(function (error) {
  //       // SetLoading(false);
  //       // this.returnResult(false);
  //     });
  //   loadingRef.current = false;
  //   if (!bool) {
  //     this.returnResult(true);
  //   }
  // }
  //blackORchid OTP
  function getBlackOrchidOTP([mobile], bool) {
    loadingRef.current = true;
    // console.log("getting");
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // SetphNum(num);
    // SetLoading(true);
    headers.append("Content-Type", "application/json");

    let data = {
      phone_number: mobile,
      qr_id: 1,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://ve2gcu3nyeuftn6eakzhcre52u0nhxca.lambda-url.ap-south-1.on.aws/",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        //  console.log(response.data);
        localStorage.setItem("otp_id", response.data.insert_otp.id);
        localStorage.setItem("user_id", response.data.user.id);
        // loadingRef.current = false;
        this.returnResult(true);
        // SetLoading(false);
        // navigate("/verify-otp", {
        //   state: {
        //     otp_id: response.data.insert_otp.id,
        //     user_id: response.data.user.id,
        //     phone_number: sender.data.mobile,
        //   },
        // });
      })
      .catch(function (error) {
        // SetLoading(false);
        this.returnResult(false);
      });
    loadingRef.current = false;
    //this.returnResult(true);
  }

  async function verificationSkodaMember([mobile]) {
    loadingRef.current = true;
    //  console.log("getting");
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // SetphNum(num);
    // SetLoading(true);
    headers.append("Content-Type", "application/json");

    let data = {
      // phone_number: mobile,
      _phone: mobile.toString(),
    };

    // const response = await axios.post(url, data, { headers });
    const resp = await axios
      .post("https://backend.extraa.in/api/rest/skodagurudev", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoieXV2YW5lc2hzIiwiaWF0IjoxNjg1NjE4MDQzLCJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsic2FsZXMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoic2FsZXMiLCJ4LWhhc3VyYS11c2VyLWlkIjoiMTc3NSIsIngtaGFzdXJhLW1lcmNoYW50LWlkIjoiMTA2MCJ9fQ.h47FQfJO0pVM1cwasqslCN2vsq2huIFw918HxeN9VYk",
          "x-hasura-admin-secret": "aseraadmin@1234",
        },
      })
      .then(function (response) {
        //  console.log('skoda member res',response.data);
        // loadingRef.current = false;
        return response.data;
      })
      .catch(function (error) {
        // SetLoading(false);
        // this.returnResult(false);
      });

    if (resp.users.length > 0) {
      // setSkodaObj(resp.users[0])
      skodaObj.current = resp.users[0];
      survey2.setValue("name", resp.users[0].name);
      // console.log(resp.users)
      getOTP([mobile], true, loadingRef);
    }
    loadingRef.current = false;
    //  console.log('skoda',resp.users);
    this.returnResult(resp.users.length > 0);
  }

  // apex prefill
  async function GetApexMember([mobile]) {
    loadingRef.current = true;
    // console.log(mobile);
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // SetphNum(num);
    // SetLoading(true);
    headers.append("Content-Type", "application/json");
    const { data } = await client.query({
      query: GetApexStatesQuery,
      variables: { where: { "emp_no": { "_eq": parseInt(mobile) } } },
      context: {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
        }
      }
    });
    // console.log(data, 'data');
    if (data?.misc_apex_data?.length > 0) {
      survey2.setValue("name", data.misc_apex_data[0].name);
      survey2.setValue("designation", data.misc_apex_data[0].designation);
      survey2.setValue("hq", data.misc_apex_data[0].hq);

    }
    this.returnResult(true);
  }

  //BlackOrchid Verification
  async function verificationBlackOrchid([mobile]) {
    //console.log(mobile);
    loadingRef.current = true;
    //  console.log("getting");
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // SetphNum(num);
    // SetLoading(true);
    headers.append("Content-Type", "application/json");

    let data = {
      // phone_number: mobile,
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current.toString(),
    };
    const resp = await axios
      .post(
        "https://0kx96rd1z1.execute-api.ap-south-1.amazonaws.com/",
        data
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //    // Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoieXV2YW5lc2hzIiwiaWF0IjoxNjg1NjE4MDQzLCJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsic2FsZXMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoic2FsZXMiLCJ4LWhhc3VyYS11c2VyLWlkIjoiMTc3NSIsIngtaGFzdXJhLW1lcmNoYW50LWlkIjoiMTA2MCJ9fQ.h47FQfJO0pVM1cwasqslCN2vsq2huIFw918HxeN9VYk",
        //     "x-hasura-admin-secret": "aseraadmin@1234",
        //   },
        // }
      )
      .then(function (response) {
        // console.log('skoda member res', response.data);
        // loadingRef.current = false;
        return response.data;
      })
      .catch(function (error) {
        // SetLoading(false);
        // this.returnResult(false);
      });
    // console.log(resp.alreadyDone);
    // console.log(resp);
    if (
      resp?.user?.users.length === 0 ||
      resp?.user?.users[0]?.user_metadata.length === 0
    ) {
      const value =
        resp?.user?.user_metadata[0]?.metadata?.membership_no.split("-") || "";
      blackOrchidId.current =
        (value[1] && `TM-${parseInt(value[1]) + 1}`) || "TM-501";
      survey2.setValue("alreadyDone", false);
      getBlackOrchidOTP([mobile], true);
    } else {
      if (token) {
        survey2.setValue("alreadyDone", true);
        survey2.setValue("name", resp?.user?.name);
      } else {
        survey2.setValue("alreadyDone", "notoken");
        getBlackOrchidOTP([mobile], true);
      }
      survey2.setValue("name", resp?.user?.users[0]?.name);
    }
    // console.log('val', blackOrchidId.current);
    loadingRef.current = false;
    //  console.log('skoda',resp.users);
    this.returnResult(true);
  }
  // AlreadyDone verifiaction using Mobile
  async function verifyAlreadyDone([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current.toString(),
    };
    const resp = await axios
      .post("https://0kx96rd1z1.execute-api.ap-south-1.amazonaws.com/", data)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) { });
    // console.log(resp.alreadyDone, 417);
    if (!resp.alreadyDone) {
      // console.log(1);
      survey2.setValue("alreadyDone", false);
    } else {
      // console.log(2);
      survey2.setValue("alreadyDone", true);
    }
    loadingRef.current = false;
    this.returnResult(true);
  }

  async function normalAlreadyDone([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current.toString(),
    };
    const resp = await axios
      .post("https://0kx96rd1z1.execute-api.ap-south-1.amazonaws.com/", data)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) { });
    // console.log(resp?.alreadyDone, 417);
    if (resp?.alreadyDone) {
      // console.log(1);
      this.returnResult(false);
    } else {
      // console.log(2);
      this.returnResult(true);
    }
    loadingRef.current = false;
  }

  //emp number verify
  async function empNumberVerify([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      like: "tvs_id",
      survey_id: surveyIdRef.current,
    };
    const resp = await axios
      .post(
        "https://5sajhu4ngmgialhzcckugjjpji0xoatd.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    if (resp?.users?.length > 0 && resp?.survey_responses?.length === 0) {
      getOTP([mobile], true, loadingRef);
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }
    // console.log('verified');
    loadingRef.current = false;
    // this.returnResult(true);
  }

  //emp id verify
  async function empIdVerify([empId]) {
    loadingRef.current = true;
    if (!empId) {
      this.returnResult(false);
      return;
    }
    // console.log('right');
    headers.append("Content-Type", "application/json");
    let data = {
      contains: [{ kauvery_id: empId }],
    };
    const resp = await axios
      .post(
        "https://nlitsxw24q6inqms5hq6jjk32e0qvwcc.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    if (resp.users?.length === 0) {
      this.returnResult(false);
    } else {
      this.returnResult(true);
    }
    loadingRef.current = false;
  }

  //emailAuthentication
  async function emailAuthentication([email]) {
    loadingRef.current = true;
    //  console.log("getting");
    const url = `https://m9jjhja4gl.execute-api.ap-south-1.amazonaws.com/GetByjusUsers/${email}`;

    const response = await axiosGet(url, "");
    if (response.body) {
      this.returnResult(true);
      // console.log("success", response);
    } else {
      this.returnResult(false);
      console.log("error");
    }
  }

  const authToken =
    mtoken ||
    `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTY4MDI2MDk1NiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.idq3fyqbnemJdsq5IrAhBNc2P5iXic4w6TmRp7sRaxM`;

  async function verifyCouponCode([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // SetphNum(num);
    // SetLoading(true);
    headers.append("Content-Type", "application/json");
    const found = mobile && mobile.toString().replaceAll('#', '')
    // console.log(mobile, 'val');
    // let couponCode = found ? mobile.slice(1): mobile;
    const couponCode = parseInt(found, 16);
    redeemCode.current = couponCode / 121;
    const data = { ucoupon_id: couponCode / 121, token: authToken, coupon_code: found };
    // const response = await axios.post(url, data, { headers });
    const resp = await axios
      .post("https://plswlr52lif4wq2vlvkawvmyum0gcgqh.lambda-url.ap-south-1.on.aws/", data)
      .then(function (response) {
        //  console.log('skoda member res',response.data);
        // loadingRef.current = false;
        return response.data;
      })
      .catch(function (error) {
        // SetLoading(false);
        this.returnResult(false);
      });

    if (resp.user_coupons_by_pk && !resp.user_coupons_by_pk.redeemed &&
      !moment(resp?.user_coupons_by_pk?.coupon?.expiry_date).isSameOrBefore(moment(), 'day')) {
      // console.log(resp, "data");
      const { coupon, user } = resp.user_coupons_by_pk;
      const percentage = coupon?.amount || coupon?.offer_title?.match(/\d+/g) || coupon?.name[coupon?.name?.indexOf('%') - 1];
      const tag = user?.tags?.find(obj => obj.hasOwnProperty('gogas_user_type'))
      const maxAmt = acc_data?.token?.space_accounts[0]?.space?.details?.discount[percentage]
      // console.log(maxAmt);
      survey2.setValue("offer_amount", percentage);
      survey2.setValue("max_amount", maxAmt);
      survey2.setValue("username", user.name);
      survey2.setValue("phone_number", user.phone_number);
      survey2.setValue("couponName", coupon.name);
      survey2.setValue("offer_title", coupon.offer_title);
      survey2.setValue("subtitle", coupon.offer_subtitle);
      survey2.setValue("user_id", user.id);
      survey2.setValue("gogas_user_type", tag?.gogas_user_type);
      survey2.setValue("created_staff_no", resp.gogas_user?.length > 0 && resp.gogas_user[0].staff_number || "");
      survey2.setValue("vehicle_number", resp.gogas_user?.length > 0 && resp.gogas_user[0].vehicle_number || "");
      //acc_data?.token?.space_accounts[0]?.space?.gogas_rsp
      // survey2.setValue(
      //   "metadata",  
      //   `${user?.metadata?.model}, ${user?.metadata?.chassis_no || user?.metadata?.chasiss_no
      //   }`
      // );
      survey2.setValue("account_id", localStorage.getItem("accid"));
      survey2.setValue("merchant_id", localStorage.getItem("mer_id"));
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }
    loadingRef.current = false;
    //  console.log('skoda',resp.users);
  }

  //new gogas card validator 
  async function validateGogasCard([cardNumber]) {
    loadingRef.current = true;
    if (!cardNumber) {
      this.returnResult(false);
      return;
    }

    const data = { code: cardNumber.replace('#', ""), token: authToken };

    const resp = await axios
      .post("https://wt6pswegnivvekb63jusb7zfwe0mmgcq.lambda-url.ap-south-1.on.aws/", data)
      .then(function (response) {
        //  console.log('skoda member res',response.data);
        // loadingRef.current = false;
        return response.data;
      })
      .catch(function (error) {
        // SetLoading(false);
        this.returnResult(false);
      });

    if (JSON.stringify(resp) == "{}") {
      this.returnResult(false);
    }

    console.log(resp, 'card number');
    if (resp?.gogas_user_profile?.length > 0 && resp?.gogas_user_profile[0]?.gogas_wallets?.length > 0
      && resp?.gogas_user_profile[0]?.gogas_wallets[0]?.balance
    ) {
      const cashback = acc_data?.token?.details?.cashback || 10
      // if (data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance < cashback) {
      //   survey2.setValue("offer_amount", data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      // } else {
      // console.log('wallet user');

      let per = 0
      if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp > 60) {
        per = 15
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp >= 54) {
        per = 10
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp < 54) {
        per = 5
      }
      const resp_offer = resp?.gogas_user_profile[0]?.user_type === "existing lpg customer" ?
        resp?.gogas_user_profile[0]?.discount_percentage
        : per
      const maxAmt = resp?.gogas_user_profile[0]?.user_type === "existing lpg customer" ? Math.floor(resp?.gogas_user_profile[0]?.maxCap * (resp?.gogas_user_profile[0]?.discount_percentage / (resp?.gogas_user_profile[0]?.discount_percentage + 100))) : 0
      console.log(maxAmt, resp_offer);
      survey2.setValue("rsp_offer", resp_offer)
      survey2.setValue("wallet_max_amount", maxAmt);
      survey2.setValue("wallet_balance", resp?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      survey2.setValue("username", resp?.gogas_user_profile[0]?.name)
      survey2.setValue("phone_number", resp?.gogas_user_profile[0]?.phone_number)
      survey2.setValue("vehicle_number", resp?.gogas_user_profile[0]?.vehicle_number || "");
      survey2.setValue("vehicle_type", resp?.gogas_user_profile[0]?.vehicle_type || "");
      // survey2.setValue("wallet_offer_amount", cashback)
      survey2.setValue("rfid", resp?.rfid);
      survey2.setValue("wallet_user", "true")
      // survey2.setValue("balance", resp?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      // survey2.setValue("username", resp?.gogas_user_profile[0]?.name)
      // survey2.setValue("phone_number", resp?.gogas_user_profile[0]?.phone_number)
      // }
      if (resp?.gogas_user_profile[0]?.max_freq > resp?.gogas_wallet_transactions_aggregate?.aggregate?.count) {
        this.returnResult(true);
      } else {
        this.returnResult(false);
      }
    } else if (resp.user_coupons_by_pk && !resp.user_coupons_by_pk.redeemed &&
      !moment(resp?.user_coupons_by_pk?.coupon?.expiry_date).isSameOrBefore(moment(), 'day')) {
      // console.log(resp.user_coupons_by_pk, "data");
      const { coupon, user } = resp.user_coupons_by_pk;
      const couponCode = "#" + (resp.user_coupons_by_pk.id * 121).toString(16).padStart(6, "0").toUpperCase()
      const percentage = coupon?.amount || coupon?.offer_title?.match(/\d+/g) || coupon?.name[coupon?.name?.indexOf('%') - 1];
      const tag = user?.tags?.find(obj => obj.hasOwnProperty('gogas_user_type'))
      const maxAmt = acc_data?.token?.space_accounts[0]?.space?.details?.discount[percentage]
      // console.log(maxAmt);
      survey2.setValue("offer_amount", percentage);
      survey2.setValue("rfid", resp?.rfid);
      survey2.setValue("coupon_code", couponCode);
      survey2.setValue("max_amount", maxAmt);
      survey2.setValue("username", user.name);
      survey2.setValue("phone_number", user.phone_number);
      survey2.setValue("couponName", coupon.name);
      survey2.setValue("offer_title", coupon.offer_title);
      survey2.setValue("subtitle", coupon.offer_subtitle);
      survey2.setValue("user_id", user.id);
      survey2.setValue("gogas_user_type", tag?.gogas_user_type);
      survey2.setValue("created_staff_no", resp.gogas_user?.length > 0 && resp.gogas_user[0].staff_number || "");
      survey2.setValue("vehicle_number", resp.gogas_user?.length > 0 && resp.gogas_user[0].vehicle_number || "");
      // survey2.setValue(
      //   "metadata",  
      //   `${user?.metadata?.model}, ${user?.metadata?.chassis_no || user?.metadata?.chasiss_no
      //   }`
      // );
      survey2.setValue("account_id", localStorage.getItem("accid"));
      survey2.setValue("merchant_id", localStorage.getItem("mer_id"));
      this.returnResult(true);
    } else {
      survey2.setValue("wallet_user", "fuel")
      survey2.setValue("rfid", resp?.rfid);
      survey2.setValue("username", resp?.gogas_user[0]?.name)
      survey2.setValue("phone_number", resp?.gogas_user[0]?.phone_number)
      survey2.setValue("created_staff_no", resp.gogas_user?.length > 0 && resp.gogas_user[0].staff_number || "");
      survey2.setValue("vehicle_number", resp.gogas_user?.length > 0 && resp.gogas_user[0].vehicle_number || "");
      survey2.setValue("vehicle_type", resp.gogas_user?.length > 0 && resp.gogas_user[0].vehicle_type || "");
      this.returnResult(true);
    }

    loadingRef.current = false;
    // this.returnResult(true);
  }

  // Verify OTP
  async function verifyOTP([otp]) {
    // SetLoading(true);
    loadingRef.current = true;
    //  console.log("verifyOTP");
    let data = JSON.stringify({
      otp: otp,
      id: localStorage.otp_id,
      user_id: localStorage.user_id,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://faas-blr1-8177d592.doserverless.co/api/v1/web/fn-5eb492b6-735e-4a32-8582-c80db698fb7e/user/verify-otp",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const validation = await axios(config)
      .then(function (response) {
        // SetOtpLoading(false);
        // console.log(response);
        // console.log(response.data);
        if (response.data.status) {
          localStorage.setItem("token", response.data.token);
          // localStorage.setItem("user_id", location.state.user_id);

          // this.returnResult(true);
          return true;
        } else {
          // SetOtpError(true);
          // throw new Error(`Invalid OTP`);
          this.returnResult(false);
          return false;
          // return;
        }
      })
      .catch(function (error) {
        // throw new Error(`HTTP error! Status: ${error}`);
      });

    // this.returnResult(validation);

    this.returnResult(validation);
    loadingRef.current = false;
  }
  const today = moment().format("YYYY-MM-DD");
  const { surveyLoading, error, data } = useQuery(GetSurvey, {
    variables: { url: params.survey_url, _gt: today },
    context: {
      headers: setInitalHeaders(),
    },
  });

  // console.log(data, 'data');

  const googleLink =
    (data?.surveys?.length > 0 &&
      data?.surveys[0]?.survey_qrs?.length > 0 &&
      data?.surveys[0]?.survey_qrs[0]?.qr?.spaces_qrs?.length > 0 &&
      data?.surveys[0]?.survey_qrs[0]?.qr?.spaces_qrs[0]?.space
        ?.google_rating_page) ||
    "";
  const qrId =
    (data?.surveys?.length > 0 &&
      data?.surveys[0]?.survey_qrs?.length > 0 &&
      data?.surveys[0]?.survey_qrs[0]?.qr?.id) ||
    null;
  const randomCoupons =
    (data?.surveys?.length > 0 &&
      data?.surveys[0]?.survey_qrs?.length > 0 &&
      data?.surveys[0]?.survey_qrs[0]?.qr?.dist_coupon_amount) ||
    0;
  const qrLocation =
    data?.surveys?.length > 0 &&
    data?.surveys[0]?.survey_qrs?.length > 0 &&
    data?.surveys[0]?.survey_qrs[0]?.qr.spaces_qrs.length > 0 &&
    data?.surveys[0]?.survey_qrs[0]?.qr?.spaces_qrs[0]?.space?.location;
  const industries =
    data?.surveys?.length > 0 && data?.surveys[0]?.merchant?.industry;
  // console.log(googleLink, 'googlelink', data)

  //membership survey function
  async function generalAlreadyDone([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");

    let data = {
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current.toString(),
    };
    // console.log(data, "data");
    const resp = await axios
      .post(
        "https://kvmcavvzrbqvpifb6e5fv7qmlm0ozlnc.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        console.log('skoda member res', response.data);
        // loadingRef.current = false;
        return response.data;
      })
      .catch(function (error) {
        // SetLoading(false);
        // this.returnResult(false);
      });
    // console.log(resp.alreadyDone);
    // console.log(resp);
    if (!resp?.alreadyDone) {
      survey2.setValue("alreadyDone", false);
      getBlackOrchidOTP([mobile], true);
    } else {
      if (token) {
        survey2.setValue("alreadyDone", true);
        survey2.setValue("name", resp?.user?.name);
        survey2.setValue("mobile", data?.phone_number);
      } else {
        survey2.setValue("alreadyDone", "notoken");
        getBlackOrchidOTP([mobile], true);
      }
      survey2.setValue("name", resp?.user?.users[0]?.name);
      survey2.setValue("mobile", data?.phone_number);
    }
    loadingRef.current = false;
    this.returnResult(true);
  }

  async function gogasUserValidate([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // console.log('right');
    headers.append("Content-Type", "application/json");

    let data = {
      phone_number: mobile.toString(),
      // "coin_type": 7
    };

    if (/^[a-zA-Z]/.test(mobile)) {
      data = {
        "vehicle_number": mobile.toString()
      }
    }

    const resp = await axios
      .post(
        "https://v7wrknevmzeste3irdoe4ih6lq0noxkm.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // if (resp.wallet?.length === 0) {
    //   this.returnResult(false);
    // } else {
    //   const userId = resp.wallet?.length > 0 && resp?.wallet[0]?.user?.id
    //   const metadata = resp.wallet?.length > 0 && resp?.wallet[0]?.metadata?.firstPurchase || ''
    //   survey2.setValue("user_id", userId);
    //   survey2.setValue("firstPurchase", metadata);
    //   survey2.setValue("name", resp.wallet?.length > 0 && resp?.wallet[0]?.user?.name);
    //   survey2.setValue("balance", resp.wallet?.length > 0 && resp?.wallet[0]?.balance || 0);
    //   this.returnResult(true);
    // }
    // console.log(resp, 'resp');
    if (Array.isArray(resp) && resp?.length > 0) {
      survey2.setValue("mobile", resp[0]?.phone_number)
      survey2.setValue("vehicleNumber", resp[0]?.vehicle_number || '')
      survey2.setValue("vehicle_type", resp[0]?.vehicle_type || '')
    } else {
      survey2.setValue("regUser", "false");
    }
    this.returnResult(true);
    loadingRef.current = false;
  }

  async function gogasUserValidatePh([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // console.log('right');
    headers.append("Content-Type", "application/json");

    let data = {
      phone_number: mobile.toString(),
      // "coin_type": 7
    };

    const resp = await axios
      .post(
        "https://v7wrknevmzeste3irdoe4ih6lq0noxkm.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    if (Array.isArray(resp) && resp?.length > 0) {
      survey2.setValue("user_id", resp[0]?.id);
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }
    loadingRef.current = false;
  }

  async function gogasUserCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current,
    };
    // console.log(data, 'variables');
    const resp = await axios
      .post(
        "https://krr53agste43dqselzjojloeiu0webjt.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    survey2.setValue("already_done", resp.alreadyDone)
    if (resp.alreadyDone) {
      this.returnResult(false);
    } else {
      this.returnResult(true);
    }

    loadingRef.current = false;
  }

  async function gogasUserPrefill([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      survey_id: surveyIdRef.current,
    };
    // console.log(data, 'variables');
    const resp = await axios
      .post(
        "https://krr53agste43dqselzjojloeiu0webjt.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // survey2.setValue("already_done", resp.alreadyDone)
    if (resp.alreadyDone) {
      survey2.setValue("name", resp.name)
      survey2.setValue("already", true)
      survey2.setValue("vehicle_type", resp.vehicle_type)
      survey2.setValue("vehicle_number", resp.vehicle_number)
      survey2.setValue("mobile_type", resp.mobile_type)
      survey2.setValue("trading_area", resp.trading_area)
      survey2.setValue("res_address", resp.res_address)
      survey2.setValue("image_url", resp.image_url)
      survey2.setValue("user_type", resp?.user_type || '')
      survey2.setValue("vehicle_file", resp?.vehicle_file || '')
    }
    if (surveyIdRef.current === 1780) {
      survey2.setValue("station_name", "")
      survey2.setValue('erp_code', "")
      survey2.setValue('city', "")
      survey2.setValue('state', "")
    }
    // if (resp.alreadyDone) {
    //   this.returnResult(false);
    // } else {
    this.returnResult(true);
    // }
    // this.returnResult(false);
    loadingRef.current = false;
  }

  //gogas user profile check
  async function gogasUserProfileCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }

    const { data } = await client.query({
      query: GetGogasUsers,
      variables: { _eq: mobile.toString() },
      context: {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
        }
      }
    });

    // console.log(data, 'data');
    if (data?.gogas_user_profile?.length > 0 && data?.gogas_user_profile[0]?.gogas_wallets?.length > 0) {
      this.returnResult(false);
    } else {
      this.returnResult(true);
    }

  }

  // Rotary Attedance check using QR's
  async function rotaryCheckIn([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      "phone_number": mobile.toString(),
      'survey_id': surveyIdRef.current
    }
    const resp = await axios.post("https://5dsaijojtdimpcf7de3zzpzx3e0ilfba.lambda-url.ap-south-1.on.aws/", data)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // console.log(resp, 'response');
    if (resp?.error) {
      this.returnResult(false);
    }
    else {
      this.returnResult(true);
      loadingRef.current = false;
    }
  }
  async function DynamicDataPrefill([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const res = await GetSurveyDetails(mobile.toString(), surveyIdRef.current);

    if (Array.isArray(res) && res.length > 0) {
      const data = res[0];
      survey2.setValue("res_id", data.id);
      console.log(data.id, "data");
      const details = data?.response_details || {};
      Object.entries(details).forEach(([key, value]) => {
        if (value != null) {
          survey2.setValue(key, value);
        }
      });
    }
    this.returnResult(true);
  }

  async function maheshwariPrefill([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const res = await GetSurveyDetails(mobile.toString(), surveyIdRef.current);
    // console.log(res);
    if (Array.isArray(res) && res.length > 0) {
      const data = res[0]
      survey2.setValue("res_id", data.id);
      survey2.setValue("Blood Group", data?.response_details['Blood Group']);
      survey2.setValue("Qualification", data?.response_details['Qualification']);
      survey2.setValue("degree", data?.response_details['degree']);
      survey2.setValue("Qualification-Comment", data?.response_details['Qualification-Comment']);
      survey2.setValue("Surname", data?.response_details['Surname']);
      survey2.setValue("industry", data?.response_details['industry']);
      survey2.setValue("mobile", data?.response_details['mobile']);
      survey2.setValue("name", data?.response_details['name']);
      survey2.setValue("homeadd", data?.response_details['homeadd']);
      survey2.setValue("homearea", data?.response_details['homearea']);
      survey2.setValue("homecity", data?.response_details['homecity']);
      survey2.setValue("homepin", data?.response_details['homepin']);
      survey2.setValue("officeadd", data?.response_details['officeadd']);
      survey2.setValue("offarea", data?.response_details['offarea']);
      survey2.setValue("offcity", data?.response_details['offcity']);
      survey2.setValue("offpincode", data?.response_details['offpincode']);
      survey2.setValue("father1", data?.response_details['father1']);
      survey2.setValue("native1", data?.response_details['native1']);
      survey2.setValue("industry", data?.response_details['industry']);
      survey2.setValue("businessothers", data?.response_details['businessothers']);
      survey2.setValue("aadhaarno", data?.response_details['aadhaarno']);
      survey2.setValue("question1", data?.response_details['question1']);
      survey2.setValue("question2", data?.response_details['question2']);
      survey2.setValue("question3", data?.response_details['question3']);
      survey2.setValue("question4", data?.response_details['question4']);
      survey2.setValue("question5", data?.response_details['question5']);
      survey2.setValue("question6", data?.response_details['question6']);
      survey2.setValue("question8", data?.response_details['question8']);
      survey2.setValue("question9", data?.response_details['question9']);
      survey2.setValue("question10", data?.response_details['question10']);
      survey2.setValue("question11", data?.response_details['question11']);
      survey2.setValue("question13", data?.response_details['question13']);
      survey2.setValue("question14", data?.response_details['question14']);
      survey2.setValue("question15", data?.response_details['question15']);
      survey2.setValue("question16", data?.response_details['question16']);
      survey2.setValue("question19", data?.response_details['question19']);
      survey2.setValue("question20", data?.response_details['question20']);
      survey2.setValue("question21", data?.response_details['question21']);
      survey2.setValue("question22", data?.response_details['question22']);
      survey2.setValue("question23", data?.response_details['question23']);
      survey2.setValue("question24", data?.response_details['question24']);
      survey2.setValue("question43", data?.response_details['question43']);
      survey2.setValue("sector", data?.response_details['sector']);
      survey2.setValue("status", data?.response_details['status']);
      survey2.setValue('dob1', data?.response_details['dob1']);
      survey2.setValue('email1', data?.response_details['email1'])
    }
    // getOTP([mobile], true, loadingRef);
    this.returnResult(true);
  }

  // jito prefill
  async function jitoPrefill([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const res = await GetSurveyDetails(mobile.toString(), surveyIdRef.current);
    // console.log(res);
    if (Array.isArray(res) && res.length > 0) {
      const data = res[0]
      survey2.setValue("res_id", data.id);
      survey2.setValue("mobile", data?.response_details['mobile']);
      survey2.setValue('membership_type', data?.response_details['membership_type'])
      survey2.setValue('name', data?.response_details['name'])
      survey2.setValue('mobile', data?.response_details['mobile'])
      survey2.setValue('uid', data?.response_details['uid'])
      survey2.setValue('membership_type', data?.response_details['membership_type'])
      survey2.setValue('chapter', data?.response_details['chapter'])
      survey2.setValue('unit', data?.response_details['unit'])
      survey2.setValue('zone', data?.response_details['zone'])
      survey2.setValue('title', data?.response_details['title'])
      survey2.setValue('fname', data?.response_details['fname'])
      survey2.setValue('mname', data?.response_details['mname'])
      survey2.setValue('surname', data?.response_details['surname'])
      survey2.setValue('member_name', data?.response_details['member_name'])
      survey2.setValue('email', data?.response_details['email'])
      survey2.setValue('company', data?.response_details['company'])
      survey2.setValue('desgi', data?.response_details['desgi'])
      survey2.setValue('industry1', data?.response_details['industry1'])
      survey2.setValue('sector1', data?.response_details['sector1'])
      survey2.setValue('dob-doc', data?.response_details['dob-doc'])
      survey2.setValue('dob-cel', data?.response_details['dob-cel'])
      survey2.setValue('anniversary', data?.response_details['anniversary'])
      survey2.setValue('blood_group', data?.response_details['blood_group'])
      survey2.setValue('area', data?.response_details['area'])
      survey2.setValue('city', data?.response_details['city'])
      survey2.setValue('pincode', data?.response_details['pincode'])
      survey2.setValue('res_address', data?.response_details['res_address'])
      survey2.setValue('code', data?.response_details['code'])
      survey2.setValue('residence_contact', data?.response_details['residence_contact'])
      survey2.setValue('mother_tongue', data?.response_details['mother_tongue'])
      survey2.setValue('native', data?.response_details['native'])
      survey2.setValue('father_name', data?.response_details['father_name'])
      survey2.setValue('spouse_name', data?.response_details['spouse_name'])
      survey2.setValue('spouse_dob', data?.response_details['spouse_dob'])
      survey2.setValue('spouse_blood', data?.response_details['spouse_blood'])
      survey2.setValue('childrendetails', data?.response_details['childrendetails'])
      survey2.setValue('childcount', data?.response_details['childcount'])
      survey2.setValue('child1', data?.response_details['child1'])
      survey2.setValue('childname1', data?.response_details['childname1'])
      survey2.setValue('gender1', data?.response_details['gender1'])
      survey2.setValue('childdob1', data?.response_details['childdob1'])
      survey2.setValue('dob1', data?.response_details['dob1'])
      survey2.setValue('maritalstatus1', data?.response_details['maritalstatus1'])
      survey2.setValue('childblood1', data?.response_details['childblood1'])
      survey2.setValue('child2', data?.response_details['child2'])
      survey2.setValue('childname2', data?.response_details['childname2'])
      survey2.setValue('gender2', data?.response_details['gender2'])
      survey2.setValue('childdob2', data?.response_details['childdob2'])
      survey2.setValue('maritalstatus2', data?.response_details['maritalstatus2'])
      survey2.setValue('childblood2', data?.response_details['childblood2'])
      survey2.setValue('child3', data?.response_details['child3'])
      survey2.setValue('childname3', data?.response_details['childname3'])
      survey2.setValue('gender3', data?.response_details['gender3'])
      survey2.setValue('childdob3', data?.response_details['childdob3'])
      survey2.setValue('maritalstatus3', data?.response_details['maritalstatus3'])
      survey2.setValue('childblood3', data?.response_details['childblood3'])
      survey2.setValue('nominee', data?.response_details['nominee'])
      survey2.setValue('nomineeadd', data?.response_details['nomineeadd'])
      survey2.setValue('nomineecity', data?.response_details['nomineecity'])
      survey2.setValue('nomineepincode', data?.response_details['nomineepincode'])
      survey2.setValue('relation_member', data?.response_details['relation_member'])
      survey2.setValue('contact', data?.response_details['contact'])
      survey2.setValue('nomineecompany', data?.response_details['nomineecompany'])
      survey2.setValue('designation', data?.response_details['designation'])
      survey2.setValue('offarea', data?.response_details['offarea'])
      survey2.setValue('offcity', data?.response_details['offcity'])
      survey2.setValue('offpincode', data?.response_details['offpincode'])
      survey2.setValue('offadd', data?.response_details['offadd'])
      survey2.setValue('offcontactcode', data?.response_details['offcontactcode'])
      survey2.setValue('coo_con_num', data?.response_details['coo_con_num'])
      survey2.setValue('cooname', data?.response_details['cooname'])
      survey2.setValue('coomobile', data?.response_details['coomobile'])
      survey2.setValue('cooemail', data?.response_details['cooemail'])
      survey2.setValue('industry', data?.response_details['industry'])
      survey2.setValue('sector', data?.response_details['sector'])
      survey2.setValue('jitooffer', data?.response_details['jitooffer'])
      survey2.setValue('other', data?.response_details['other'])
      survey2.setValue('socialclub', data?.response_details['socialclub'])
    }
    // getOTP([mobile], true, loadingRef);
    this.returnResult(true);
  }

  // ec cards check 
  async function ecCardsCheck([mobile, qr_code]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }

    const arr = qr_code?.split('/')
    const qr = arr[arr?.length - 1] || qr_code

    const { ec_cards, ec_users } = await GetECCardsDetails(mobile?.toString(), qr)
    // console.log(res);
    if (Array.isArray(ec_cards) && ec_cards.length > 0) {
      survey2.setValue('user_id', ec_users?.length > 0 && ec_users[0]?.id || 0)
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }
  }

  //LPG Cards update function
  async function GetLPGCard([mobile, qr_code]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }

    const { gogas_users, gogas_lpg_cards, users, already_check, gogas_new_registrations } = await GetLPGardsDetails(mobile?.toString(), qr_code.replace('#', ''))
    // console.log(gogas_users, gogas_lpg_cards, users, already_check, gogas_new_registrations);

    if (already_check?.length > 0 && already_check[0]?.id) {
      this.returnResult(false);
    }

    if (Array.isArray(gogas_lpg_cards) && gogas_lpg_cards.length > 0 && gogas_lpg_cards[0]?.rfid) {
      survey2.setValue('user_id', gogas_new_registrations?.length > 0 && users?.length > 0 && users[0]?.id || 0)
      survey2.setValue('gogas_user_id', gogas_new_registrations?.length > 0 && gogas_users?.length > 0 && gogas_users[0]?.id || 0)
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }

  }
  // AMKM user validation using 
  async function amkmUserValidaton([params]) {
    const [mobile, surveyId] = params
    loadingRef.current = true;

    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      "phone_number": mobile.toString(),
      'survey_id': surveyId.toString()
    }
    const resp = await axios.post("https://5dsaijojtdimpcf7de3zzpzx3e0ilfba.lambda-url.ap-south-1.on.aws/", data)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // console.log(resp, 'response');
    if (resp?.error) {
      this.returnResult(false);
    }
    else {
      this.returnResult(true);
      loadingRef.current = false;
    }
  }

  // Jainism AMKM UserInsert
  async function amkmJainismUserInsert(results) {
    loadingRef.current = true;
    headers.append("Content-Type", "application/json");
    let data = {
      "username": results?.name,
      "age": results?.age,
      "gender": results?.gender,
      "language": results?.language,
      "phone": results?.mobile,
      "password": results?.password,
      "area": results?.area
    }
    const url = "https://lu4psnwbmphf75oi62xkttibqq0iiamo.lambda-url.ap-south-1.on.aws/";
    const resp = await axios.post(url, data)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // console.log(resp, 'response')
  }
  async function gogasUserRedeem([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    // console.log('right');
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
      coin_type: 7,
    };
    const resp = await axios
      .post(
        "https://v7wrknevmzeste3irdoe4ih6lq0noxkm.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    if (resp.wallet?.length === 0) {
      this.returnResult(false);
    } else {
      const userId = resp.wallet?.length > 0 && resp?.wallet[0]?.user?.id;
      const metadata =
        (resp.wallet?.length > 0 && resp?.wallet[0]?.metadata?.redeemDate) ||
        "";
      const givenDate = moment(metadata);
      const currentDate = moment().startOf("day");
      survey2.setValue("user_id", userId);
      survey2.setValue(
        "name",
        (resp.wallet?.length > 0 && resp?.wallet[0]?.user?.name) || ""
      );
      if (givenDate.isSameOrBefore(currentDate, "day")) {
        // console.log("The given date is today.");
        const futureDate = moment().add(14, "days");
        const formattedFutureDate = futureDate.format("YYYY-MM-DD");
        survey2.setValue("redeemDate", formattedFutureDate);
        survey2.setValue(
          "wallet_id",
          resp.wallet?.length > 0 && resp?.wallet[0]?.id
        );
        survey2.setValue("redeemDate", formattedFutureDate);
        survey2.setValue(
          "amount",
          (resp.wallet?.length > 0 &&
            Math.floor(resp?.wallet[0]?.balance / 2)) ||
          0
        );
        survey2.setValue(
          "balance",
          (resp.wallet?.length > 0 && resp?.wallet[0]?.balance) || 0
        );
        this.returnResult(true);
      } else {
        // console.log("The given date is not today.");
        this.returnResult(false);
      }
    }
    loadingRef.current = false;
  }

  async function jolieUserCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    headers.append("Content-Type", "application/json");
    let data = {
      phone_number: mobile.toString(),
    };
    // console.log(data, 'variables');
    const resp = await axios
      .post(
        "https://4joi665nubluaetrd5h4kbp4rq0ycwup.lambda-url.ap-south-1.on.aws/",
        data
      )
      .then(function (response) {
        // console.log(response, 'resp');
        return response.data;
      })
      .catch(function (error) {
        this.returnResult(false);
      });
    // console.log(resp, 'response');
    if (resp?.error) {
      this.returnResult(false);
    } else {
      if (resp?.message === "Jolie_Member") {
        survey2.setValue("member_name", resp?.user?.name);
        survey2.setValue("member_no", resp?.user?.phone_number);
      }
      if (resp?.message === "Jolie_Guest") {
        survey2.setValue("guest_name", resp?.user?.name);
        survey2.setValue("guest_no", resp?.user?.phone_number);
        survey2.setValue(
          "referral_name",
          (resp?.user?.survey_responses?.length > 0 &&
            resp?.user?.survey_responses[0]?.response_details?.referral_name) ||
          ""
        );
        survey2.setValue(
          "referral_no",
          (resp?.user?.survey_responses?.length > 0 &&
            resp?.user?.survey_responses[0]?.response_details?.referral_no) ||
          ""
        );
      }
      this.returnResult(true);
    }

    loadingRef.current = false;
  }

  async function gogasCoinBalanceCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const { data } = await client.query({
      query: getBalanceQuery, variables: {
        "_eq": mobile.toString(),
        "date": moment().format("YYYY-MM-DD")
      },
      context: { headers: { "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTczMTA3MTI5MywiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.Hs9et4weUYR-hv8AfqqgatBH4i4QUFNMBm495NNG4t0` } }
    })
    if (data?.gogas_user_profile?.length > 0 && data?.gogas_user_profile[0]?.gogas_wallets?.length > 0) {
      const cashback = acc_data?.token?.details?.cashback || 10
      // if (data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance < cashback) {
      //   survey2.setValue("offer_amount", data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      // } else {
      survey2.setValue("offer_amount", cashback)
      survey2.setValue("wallet_balance", data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      survey2.setValue("username", data?.gogas_user_profile[0]?.name)
      survey2.setValue("phone_number", data?.gogas_user_profile[0]?.phone_number)
      // }
      if (data?.gogas_user_profile[0]?.max_freq > data?.gogas_wallet_transactions_aggregate?.aggregate?.count) {
        this.returnResult(true);
      } else if (data?.gogas_user_profile[0]?.max_freq === null) {
        this.returnResult(true);
      } else {
        this.returnResult(false);
      }
    } else {
      this.returnResult(false);
    }
    // console.log(data, 'data', data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance);
    loadingRef.current = false;
  }

  async function gogasNewCoinBalanceCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const { data } = await client.query({
      query: getBalanceQuery, variables: {
        "_eq": mobile.toString(),
        "date": moment().format("YYYY-MM-DD")
      },
      context: { headers: { "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTczMTA3MTI5MywiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.Hs9et4weUYR-hv8AfqqgatBH4i4QUFNMBm495NNG4t0` } }
    })
    if (data?.gogas_user_profile?.length > 0 && data?.gogas_user_profile[0]?.gogas_wallets?.length > 0) {
      // const cashback = acc_data?.token?.details?.cashback || 10
      // if (data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance < cashback) {
      //   survey2.setValue("offer_amount", data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      // } else {
      let per = 0
      if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp > 52 &&
        data?.gogas_user_profile[0]?.user_type === "retro fitment" &&
        data?.gogas_user_profile[0]?.state === "TN") {
        per = 15
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp >= 49 &&
        data?.gogas_user_profile[0]?.user_type === "retro fitment" &&
        data?.gogas_user_profile[0]?.state === "TN") {
        per = 10
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp < 49 &&
        data?.gogas_user_profile[0]?.user_type === "retro fitment" &&
        data?.gogas_user_profile[0]?.state === "TN") {
        per = 5
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp > 60) {
        per = 15
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp >= 54) {
        per = 10
      } else if (acc_data?.token?.space_accounts[0]?.space?.gogas_rsp < 54) {
        per = 5
      }
      const resp_offer = data?.gogas_user_profile[0]?.user_type === "existing lpg customer" ?
        data?.gogas_user_profile[0]?.discount_percentage
        : per
      const maxAmt = data?.gogas_user_profile[0]?.user_type === "existing lpg customer" ? Math.floor(data?.gogas_user_profile[0]?.maxCap * (data?.gogas_user_profile[0]?.discount_percentage / 100)) : 0
      console.log(maxAmt, resp_offer);
      survey2.setValue("rsp_offer", resp_offer)
      survey2.setValue("max_amount", maxAmt);
      survey2.setValue("wallet_balance", data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance)
      survey2.setValue("username", data?.gogas_user_profile[0]?.name)
      survey2.setValue("phone_number", data?.gogas_user_profile[0]?.phone_number)
      survey2.setValue("vehicle_number", data?.gogas_user_profile[0]?.vehicle_number || "")
      survey2.setValue("vehicle_type", data?.gogas_user_profile[0]?.vehicle_type || "")
      // }
      if (data?.gogas_user_profile[0]?.max_freq > data?.gogas_wallet_transactions_aggregate?.aggregate?.count) {
        this.returnResult(true);
      } else {
        this.returnResult(false);
      }
    } else {
      this.returnResult(false);
    }
    // console.log(data, 'data', data?.gogas_user_profile[0]?.gogas_wallets[0]?.balance);
    loadingRef.current = false;
  }

  async function gsquareGamesCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const { data } = await client.query({
      query: getGamesResQuery, variables: {
        "phone_number": mobile.toString(),
        "games_id": survey2.getValue("games_id"),
        "survey_id": surveyIdRef.current
      },
      context: { headers: { "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcyODAyMTI3OSwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.5ZcyliAH313iLf6wPc9O6dLYpBGeZSLFJFd8iSVg0TY` } }
    })
    // console.log("data", data);
    if (data?.users?.length > 0 && data?.users[0]?.game_responses?.length > 0 && data?.users[0]?.survey_responses?.length === 0) {
      this.returnResult(true);
      // console.log(data?.users[0]?.game_responses[0]?.outcome);
      survey2.setValue("name", data?.users[0]?.name)
      survey2.setValue("outcome", data?.users[0]?.game_responses[0]?.outcome?.text)
    } else {
      this.returnResult(false);
    }
    loadingRef.current = false;
  }

  const countRef = useRef(1)
  async function cngUserValidate([mobile]) {
    loadingRef.current = true;
    // if (!mobile) {
    //   this.returnResult(false);
    //   return;
    // }

    // console.log(countRef.current);

    if (countRef.current === 1) {
      countRef.current = 2;
      const result = await getAPI("https://p7b2bfbxwjvbbsq322zm3jopsm0mzhjn.lambda-url.ap-south-1.on.aws/",
        { "qr_code": mobile.toString() })
      if (result?.data?.status == 200 && result?.data?.body?.length > 0 && result?.data?.body[0]?.user?.wallet?.coin_type === 1) {
        // console.log(result.data?.body, 'data')
        // const acc_id = localStorage.getItem("accid")
        const res = await getAPI("https://4ojnsb6c63ygr32ymtlgk3es7e0lsjta.lambda-url.ap-south-1.on.aws/",
          { "phone_number": result.data?.body[0]?.user?.phone_number.toString(), "qr_code": mobile.toString() }
        )
        survey2.setValue("username", result.data?.body[0]?.user?.name);
        survey2.setValue("org_name", result.data?.body[0]?.user?.organisation?.name);
        survey2.setValue("otp_id", res.data?.otp_id);
        survey2.setValue("user_id", result.data?.body[0]?.user?.id);
        survey2.setValue("vehicle_number", result.data?.body[0]?.user?.vehicle_number);
        survey2.setValue("balance", result.data?.body[0]?.user?.wallet?.balance);
        survey2.setValue("previous_odometer", result.data?.body[0]?.previous_kms || 0);
        survey2.setValue("previous_qty", result.data?.body[0]?.previous_qty || 0);
        survey2.setValue("acc_id", decodeJWT(mtoken)["https://hasura.io/jwt/claims"]["x-hasura-cng-user-id"] || 0);
        // console.log(result.data?.body[0]?.account_id, 'data');
        this.returnResult(true)
      } else {
        this.returnResult(false);
      }
    }
    // console.log(countRef.current);

    loadingRef.current = false;
  }

  async function bantaJeeraDailyWinnerUserValidate([mobile, unique_code]) {
    loadingRef.current = true;
    // if (!mobile) {
    //   this.returnResult(false);
    //   return;
    // }
    // console.log(mobile, "mobile")
    // console.log(unique_code, "unique_code")
    // console.log(countRef.current);

    if (countRef.current === 1) {
      countRef.current = 2;

      // console.log(result.data?.body, 'data')
      // const acc_id = localStorage.getItem("accid")
      const res = await getAPI("https://wato.extraa.in/api/w/extraa-wa/jobs/run_wait_result/p/f/banta_jeera/checkDailyWinnerUserValidate",
        {
          "mobile": mobile.toString(),
          "unique_code": unique_code.toString()
        }, {
        "Content-Type": "application/json",
        "Authorization": "Bearer GukcFZxioNEPzrJkxg4NCBCWXrNRJUJ1"
      }
      )

      // console.log(res,'res')
      if (res?.data?.allow_survey) {
        // console.log(res.data.allow_survey, 'response')
        this.returnResult(true)
        return;
      } else {
        this.returnResult(false);
        return;
      }
    }
    // console.log(countRef.current);

    loadingRef.current = false;
  }

  // cng new coin balance check
  async function cngNewCoinBalanceCheck([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const response = await GetCNGCardsDetails(mobile?.replace('#', ''))
    if (response?.length > 0 && response[0]?.user?.wallet?.balance > 0) {
      survey2.setValue("username", response[0]?.user?.name);
      survey2.setValue("user_id", response[0]?.user_id);
      survey2.setValue("phone_number", response[0]?.user?.phone_number);
      survey2.setValue("wallet_balance", response[0]?.user?.wallet?.balance);
      // survey2.setValue("discount_percentage", acc_data?.token?.cng_accounts_to_extraa_accounts?.discount_percentage || 0);
      this.returnResult(true);
    } else {
      this.returnResult(false);
    }
    loadingRef.current = false;
  }

  // cng card validate
  async function cngCardValidate([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const response = await GetCNGCardsDetails(mobile?.replace('#', ''))
    if (response?.length > 0 && !response[0]?.user_id) {
      this.returnResult(true);
      return;
    } else {
      this.returnResult(false);
      return;
    }
  }
  // assign cards to users
  async function assignUserToCards([mobile, qr_code, name, country_code]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const arr = qr_code?.split('/')
    const qr = arr[arr?.length - 1] || qr_code
    // console.log(country_code.toString(), "countryCode");
    const countryCode = `+${country_code}`
    // console.log(countryCode, "countryCodemmod");

    const data = await GetEcUserDetails(mobile?.toString(), name, qr, countryCode.toString())
    // console.log(data, "userId");
    const cardsUpdatedata = {
      qr_id: data?.qr_id,
      user_id: data?.userId
    }
    if (typeof cardsUpdatedata?.qr_id !== 'undefined' && cardsUpdatedata?.user_id) {
      const carddata = await assignCardToUser(cardsUpdatedata)
      // console.log(cardsUpdatedata, "can assign card to user", typeof cardsUpdatedata?.qr_code);
      if (carddata?.data?.update_ec_cards_by_pk?.id) {
        // console.log("assigned card to user");
        this.returnResult(true);
        return;
      }
      else {
        // console.log("cannot assign card to user");
        this.returnResult(false);
        return;
      }
    }
    else {
      // console.log("cannot assign card to user");
      this.returnResult(false);
      return;
    }
  }

  async function cngUserVerifyOTP([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const result = await getAPI("https://hgi7wqeq6kog5vugape2ytzdtq0idems.lambda-url.ap-south-1.on.aws/", {
      "otp_id": survey2.getValue("otp_id"),
      "user_id": survey2.getValue("user_id"),
      "otp": mobile.toString()
    })
    // console.log(result?.data);
    if (result?.data?.status == 200) {
      this.returnResult(true)
    } else {
      this.returnResult(false);
    }
    loadingRef.current = false;
  }

  async function CheckAlreadyDone([mobile]) {
    loadingRef.current = true;
    if (!mobile) {
      this.returnResult(false);
      return;
    }
    const res = await client.query({
      query: GetSurveyResponses,
      variables: {
        "survey_id": surveyIdRef.current,
        "date": moment().format('YYYY-MM-DD'),
        "_and": [
          {
            "response_details": {
              "_cast": { "String": { "_ilike": `%\"mobile\": \"${mobile}\"%` } }
            }
          }, {
            "response_details": {
              "_cast": { "String": { "_ilike": `%\"salesname\": \"${sales_name}\"%` } }

            }

          }]
      },
      context: {
        headers: {
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcwMzkyMDQ4MCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.GmEImnsHm9zxXj2TVNsswvSA3HICCQHuYJiMtPCVZRY`
        }
      }
    })
    if (res?.data?.survey_responses?.length > 0) {
      this.returnResult(false)
    } else {
      this.returnResult(true)
    }
    // console.log(res);
    loadingRef.current = false;
    return;
  }

  FunctionFactory.Instance.register("getOTP", getOTP, true);
  FunctionFactory.Instance.register("gsquareGamesCheck", gsquareGamesCheck, true);
  FunctionFactory.Instance.register("gogasCoinBalanceCheck", gogasCoinBalanceCheck, true);
  FunctionFactory.Instance.register("gogasNewCoinBalanceCheck", gogasNewCoinBalanceCheck, true);
  FunctionFactory.Instance.register("cngNewCoinBalanceCheck", cngNewCoinBalanceCheck, true);
  FunctionFactory.Instance.register("empNumberVerify", empNumberVerify, true);
  FunctionFactory.Instance.register("empIdVerify", empIdVerify, true);
  FunctionFactory.Instance.register("verifyCouponCode", verifyCouponCode, true);
  FunctionFactory.Instance.register("validateGogasCard", validateGogasCard, true);
  FunctionFactory.Instance.register("GetLPGCard", GetLPGCard, true);
  FunctionFactory.Instance.register("assignUserToCards", assignUserToCards, true);
  FunctionFactory.Instance.register("CheckAlreadyDone", CheckAlreadyDone, true);
  FunctionFactory.Instance.register("normalAlreadyDone", normalAlreadyDone, true);
  FunctionFactory.Instance.register("cngCardValidate", cngCardValidate, true);
  FunctionFactory.Instance.register(
    "generalAlreadyDone",
    generalAlreadyDone,
    true
  );
  FunctionFactory.Instance.register(
    "verificationSkodaMember",
    verificationSkodaMember,
    true
  );
  FunctionFactory.Instance.register(
    "GetApexMember",
    GetApexMember,
    true
  );
  //blackorchid
  FunctionFactory.Instance.register(
    "verificationBlackOrchid",
    verificationBlackOrchid,
    true
  );
  //emailAuth
  FunctionFactory.Instance.register(
    "emailAuthentication",
    emailAuthentication,
    true
  );
  //verifyAlreadyDone
  FunctionFactory.Instance.register(
    "verifyAlreadyDone",
    verifyAlreadyDone,
    true
  );
  FunctionFactory.Instance.register("verifyOTP", verifyOTP, true);
  FunctionFactory.Instance.register(
    "gogasUserValidate",
    gogasUserValidate,
    true
  );
  FunctionFactory.Instance.register(
    "gogasUserValidatePh",
    gogasUserValidatePh,
    true
  );
  FunctionFactory.Instance.register("cngUserValidate", cngUserValidate, true);
  FunctionFactory.Instance.register("bantaJeeraDailyWinnerUserValidate", bantaJeeraDailyWinnerUserValidate, true);
  FunctionFactory.Instance.register("cngUserVerifyOTP", cngUserVerifyOTP, true);
  FunctionFactory.Instance.register("gogasUserRedeem", gogasUserRedeem, true);
  FunctionFactory.Instance.register("gogasUserCheck", gogasUserCheck, true);
  FunctionFactory.Instance.register("gogasUserPrefill", gogasUserPrefill, true);
  FunctionFactory.Instance.register("jolieUserCheck", jolieUserCheck, true);
  FunctionFactory.Instance.register("rotaryCheckIn", rotaryCheckIn, true);
  FunctionFactory.Instance.register("DynamicDataPrefill", DynamicDataPrefill, true);
  FunctionFactory.Instance.register("maheshwariPrefill", maheshwariPrefill, true);
  FunctionFactory.Instance.register("jitoPrefill", jitoPrefill, true);
  FunctionFactory.Instance.register("ecCardsCheck", ecCardsCheck, true);
  FunctionFactory.Instance.register("amkmUserValidaton", amkmUserValidaton, true);
  FunctionFactory.Instance.register("gogasUserProfileCheck", gogasUserProfileCheck, true);
  // Submit API
  async function submitAPI(
    phone,
    gender,
    name,
    email,
    dob,
    ageRange,
    results,
    metadata,
    surveyResponse,
    pincode,
    area,
    sales_mob
  ) {
    try {
      let req = queryParams.get("token") || localStorage.getItem("mtoken")
        ? // && surveyIdRef.current === 276
        {
          qr_id: qrIdRef.current,
          phone_number: phone.toString(),
          gender: gender,
          name: name,
          email: email,
          dob: dob,
          age_range: ageRange.toString(),
          survey_id: surveyIdRef.current.toString(),
          response_details: results,
          coupons: couponsRef.current,
          meta: metadata,
          // token: localStorage.getItem("token") || "",
          survey_responses: surveyResponse,
          allow_multiple_response: already_done.current,
        }
        : {
          qr_id: qrIdRef.current,
          phone_number: phone.toString(),
          gender: gender,
          name: name,
          email: email,
          dob: dob,
          age_range: ageRange.toString(),
          survey_id: surveyIdRef.current.toString(),
          response_details: results,
          coupons: couponsRef.current,
          meta: metadata,
          token: localStorage.getItem("token") || "",
          survey_responses: surveyResponse,
          allow_multiple_response: already_done.current,
        };
      const BlackReq =
        blackOrchidId.current !== ""
          ? {
            qr_id: qrIdRef.current,
            phone_number: phone.toString(),
            gender: gender,
            name: name,
            email: email,
            dob: dob,
            age_range: ageRange.toString(),
            survey_id: surveyIdRef.current.toString(),
            response_details: results,
            coupons: couponsRef.current,
            meta: metadata,
            // token: localStorage.getItem("token") || "",
            survey_responses: surveyResponse,
            allow_multiple_response: already_done.current,
            metaJson: {
              membership_no: blackOrchidId.current,
            },
          }
          : {
            qr_id: qrIdRef.current,
            phone_number: phone.toString(),
            gender: gender,
            name: name,
            email: email,
            dob: dob,
            age_range: ageRange.toString(),
            survey_id: surveyIdRef.current.toString(),
            response_details: results,
            coupons: couponsRef.current,
            meta: null,
            // token: localStorage.getItem("token") || "",
            survey_responses: surveyResponse,
            allow_multiple_response: already_done.current,
          };

      const mmReq = {
        location: dataRef.current?.locations,
        randomCoupons: dataRef.current?.randomCoupons || "",
        industry: dataRef.current?.industries || "",
        qr_id: qrIdRef.current,
        phone_number: phone.toString(),
        gender: gender,
        name: name,
        email: email,
        dob: dob,
        age_range: ageRange.toString(),
        survey_id: surveyIdRef.current.toString(),
        response_details: results,
        coupons: couponsRef.current,
        meta: metadata,
        token: localStorage.getItem("token") || "",
        survey_responses: surveyResponse,
        allow_multiple_response: already_done.current,
      };
      const request = {
        176: BlackReq,
        286: mmReq,
        297: mmReq,
        300: mmReq,
        302: mmReq,
        304: mmReq,
        306: mmReq,
        307: mmReq,
        309: mmReq,
        310: mmReq,
      };
      req =
        (sales_mob?.length > 0 && {
          qr_id: qrIdRef.current,
          phone_number: phone.toString(),
          gender: gender,
          name: name,
          email: email,
          dob: dob,
          age_range: ageRange.toString(),
          survey_id: surveyIdRef.current.toString(),
          response_details: results,
          coupons: couponsRef.current,
          meta: metadata,
          survey_responses: surveyResponse,
          allow_multiple_response: already_done.current,
        }) ||
        req;
      // console.log(request[surveyIdRef.current],'request')
      const res = await axios({
        // url: "https://faas-blr1-8177d592.doserverless.co/api/v1/web/fn-5eb492b6-735e-4a32-8582-c80db698fb7e/survey/submit",
        url: `https://6j8wmnnyoa.execute-api.ap-south-1.amazonaws.com/SubmitAndCoupon`,
        data: request[surveyIdRef.current] || req,
        // data: mmReq,
        method: "post",
        timeout: 9000,
        headers: {
          "Content-Type": "application/json",
        },
      });
      // if (res.status === 200) {
      //   // test for status you want, etc
      //   //  console.log(res.status);
      // }


      // const getSurvey1848ResponseCount = async (phone) => {
      //   try {
      //     const { data: responseCount } = await client.query({
      //       query: GetSurveyResponseCount,
      //       fetchPolicy: "network-only",
      //       variables: {
      //         survey_id: 1848,
      //         phone: String(phone),
      //       },
      //       context: {
      //         headers: {
      //           Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTY4MDI2MDk1NiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.idq3fyqbnemJdsq5IrAhBNc2P5iXic4w6TmRp7sRaxM`,
      //         },
      //       },
      //     });
      //     return responseCount?.survey_responses_aggregate?.aggregate?.count ?? 0;
      //   } catch (err) {
      //     console.error("1848 response count check failed:", err);
      //     return null;
      //   }
      // };
      // if (
      //   res.status === 200 &&
      //   Number(surveyIdRef.current) === 1848 &&
      //   results.result === "true"
      // ) {
      //   // one user, one time only
      //   const responseCount = await getSurvey1848ResponseCount(phone);

      //   if (responseCount == 1) {
      //     try {
      //       const lambdaResponse = await axios.post(
      //         "https://xhcajntw7a5zk2umafmn7ff2qu0ainmc.lambda-url.ap-south-1.on.aws/",
      //         {
      //           survey_id: "1848",
      //           result: "true",
      //           phone: String(phone),
      //         },
      //         { headers: { "Content-Type": "application/json" } }
      //       );
      //       console.log("Lambda status:", lambdaResponse.status);
      //     } catch (error) {
      //       console.error(
      //         "ty_contest WhatsApp failed:",
      //         error.response?.data || error.message
      //       );
      //     }
          
      //   } else {
      //     console.log("Skipping WhatsApp coupon lambda. Count:", responseCount);
      //   }
      // }

      // Don't forget to return something
      return res.data;
    } catch (err) {
      console.error(err);
    }
  }

  // Coupon redeem submit
  const couponRedeemSubmit = async (acc_id) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSZ");
    const url = "https://backend.extraa.in/api/rest/redeem-coupon";
    const authToken =
      mtoken ||
      `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTY4MDI2MDk1NiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.idq3fyqbnemJdsq5IrAhBNc2P5iXic4w6TmRp7sRaxM`;
    const variables = {
      ucoupon_id: redeemCode.current,
      redeemed_at: currentDateTime,
      redeemed_by: acc_id || 1,
    };
    const headers = {
      "Content-Type": "application/json",
      // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTcxODM1ODA4OCwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.Cc9meYUA3uyM6XcGwloAsVRk3RQZQcN9f6shBqLUM0`,
      Authorization: `Bearer ${authToken}`,
      // "x-hasura-admin-secret": "aseraadmin@1234",
    };
    const response = await getAPI(url, variables, headers);
    return response;
  };

  //coupon redeem for gogas
  const gogasRedeemSubmit = async (data) => {
    const response = await getAPI("https://gogas-api.extraa.in/coupon-transaction", data);
    // console.log(data, 'data');
    return response;
  }


  //merchant_Create
  const merchant_Create = async (results) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSZ");
    const url = "https://backend.extraa.in/api/rest/create-merchant";
    const variables =
      // ucoupon_id: redeemCode.current,
      // redeemed_at: currentDateTime,
      merchantCreation(results);
    // console.log(results)
    const headers = {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoieXV2YW5lc2hzIiwiaWF0IjoxNjg1NjE4MDQzLCJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsic2FsZXMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoic2FsZXMiLCJ4LWhhc3VyYS11c2VyLWlkIjoiMTc3NSIsIngtaGFzdXJhLW1lcmNoYW50LWlkIjoiMTA2MCJ9fQ.h47FQfJO0pVM1cwasqslCN2vsq2huIFw918HxeN9VYk",
      "x-hasura-admin-secret": "aseraadmin@1234",
    };
    const response = await getAPI(url, variables, headers);
    return response;
  };
  //Branch Create
  const branch_Create = async (results) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSZ");
    const url = "https://backend.extraa.in/api/rest/create-branch";
    const variables =
      // ucoupon_id: redeemCode.current,
      // redeemed_at: currentDateTime,
      branchCreation(results);
    // console.log(results)
    const headers = {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoieXV2YW5lc2hzIiwiaWF0IjoxNjg1NjE4MDQzLCJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsic2FsZXMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoic2FsZXMiLCJ4LWhhc3VyYS11c2VyLWlkIjoiMTc3NSIsIngtaGFzdXJhLW1lcmNoYW50LWlkIjoiMTA2MCJ9fQ.h47FQfJO0pVM1cwasqslCN2vsq2huIFw918HxeN9VYk",
      "x-hasura-admin-secret": "aseraadmin@1234",
    };
    const response = await getAPI(url, variables, headers);
    return response;
  };
  //Contact_Create
  const contact_Create = async (results) => {
    const currentDateTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSZ");
    const url = "https://backend.extraa.in/api/rest/create-contact";
    const variables =
      // ucoupon_id: redeemCode.current,
      // redeemed_at: currentDateTime,
      contactCreation(results);

    // console.log(results)
    const headers = {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoieXV2YW5lc2hzIiwiaWF0IjoxNjg1NjE4MDQzLCJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWFsbG93ZWQtcm9sZXMiOlsic2FsZXMiXSwieC1oYXN1cmEtZGVmYXVsdC1yb2xlIjoic2FsZXMiLCJ4LWhhc3VyYS11c2VyLWlkIjoiMTc3NSIsIngtaGFzdXJhLW1lcmNoYW50LWlkIjoiMTA2MCJ9fQ.h47FQfJO0pVM1cwasqslCN2vsq2huIFw918HxeN9VYk",
      "x-hasura-admin-secret": "aseraadmin@1234",
    };
    const response = await getAPI(url, variables, headers);
    return response;
  };
  //pincode
  const pincodeFetch = async (pincode, area) => {
    const url = `https://jx1bl3imuc.execute-api.ap-south-1.amazonaws.com/locations/${pincode}`;

    const response = await axiosGet(url, "");
    let error = "Object not found";
    const pincodeId = response.find((item) => item.id === area);
    if (pincodeId) {
      const locationData = {
        lat: pincodeId.lat,
        long: pincodeId.long,
        area: pincodeId.area,
        city: pincodeId.city,
        pincode: pincodeId.pincode,
        id: pincodeId.id,
      };
      return locationData;
    } else {
      return error;
    }
  };

  //MM Motors
  // if (surveyIdRef.current === 276) {
  // }
  // const quesImg= survey2.getQuestionByName('img_url')
  // if(quesImg && quesImg.cameraValue.canFlipValue){
  //  // console.log(,'question');
  //  quesImg.flipCamera()
  // }
  //  --------------------------------------------------------- SUBMIT FEEDBACK ---------
  const submitRef = useRef(1)
  const submitSurvey = useCallback(async (sender) => {
    // loadingRef.current = true;
    let results = { ...sender.data };
    delete results.data;
    // console.log(results)
    // alert(results);
    if (Number(surveyIdRef.current) === 1848) {

      const correctAnswers = {
        question: "14th Jan 1969",
        question1: "Madras state/presidency",
        question2: 124,
        question3: "O.P. Ramaswamy Reddiar",
        question4: "Madras Pattinam",
        question6: "Port city(coastal city)",
      };


      const allCorrect = Object.entries(correctAnswers).every(
        ([key, expectedAnswer]) => {
          const actualAnswer = results[key];

          if (typeof expectedAnswer === "number") {
            return Number(actualAnswer) === expectedAnswer;
          }

          return (
            String(actualAnswer).trim().toLowerCase() ===
            expectedAnswer.trim().toLowerCase()
          );
        }
      );


      results.result = String(allCorrect);
      setResultTrue(allCorrect);
    }
    const dataParam = new URLSearchParams(window.location.search).get("data");
    const decodedUser = dataParam ? decodeUserData(dataParam) : null;

    if (skodaObj.current) {
      results = {
        ...results,
        ...skodaObj.current.metadata,
        name: skodaObj.current.name,
      };
    }
    if (decodedUser) {
      if (decodedUser.name && !results.name) {
        results.name = decodedUser.name;
      }
      if (decodedUser.mobile && !results.mobile) {
        results.mobile = decodedUser.mobile;
      }
    }
    delete results.data;
    const name = decodedUser?.name || results.name || skodaObj.current.name || "";
    const phone = decodedUser?.mobile || results.mobile || "";
    const gender = results.gender;
    const email = results.email;
    const dob = results.dob;
    const age = moment().diff(dob, "years");
    const surveyResponse = {
      name: skodaObj.current.name,
      ...skodaObj.current.metadata,
    };
    const pincode =
      results.pincode || results.merchantPincode || results.branchPincode;
    const area = results.area || results.merchantArea || results.branchArea; //areaCode
    //console.log(results);
    let ageRange;

    if (age < 20) {
      ageRange = 0;
    } else if (age >= 20 && age < 40) {
      ageRange = 1;
    } else if (age >= 40 && age < 60) {
      ageRange = 2;
    } else {
      ageRange = 3;
    }

    // console.log(name, ageRange, gender, dob, phone, email);
    // console.log(survey2);
    gogasResRef.current = results
    SetLoading(true);

    if (submitRef.current === 1) {
      submitRef.current = 2
      if (surveyIdRef.current === 1660) {
        // console.log(results);
        results.survey_id = surveyIdRef.current
        let result;
        if (results?.wallet_user === "true") {
          results['extra_amount'] = results?.wallet_extra_amount
          results['amount_filled'] = results?.wallet_amount_filled
          results['offer_amount'] = results?.wallet_offer_amount
          results['vehicle_number'] = results?.vehicle_number
          results['amount'] = results?.wallet_amount
          // results['balance'] = results?.wallet_balance
          result = await gogasCoinsRedeem(results)
          setTryButton(result?.code === 200)
        } else if (results?.wallet_user === 'fuel') {
          results['amount'] = parseInt(results?.fuel_amount)
          results['vehicleNumber'] = results?.vehicle_number
          results['mobile'] = results?.phone_number
          const vari = {
            "qr_id": null,
            "phone_number": phone,
            "name": name,
            "age_range": "0",
            "survey_id": 1552,
            "response_details": results
          }
          const response = await getAPI("https://tk2reuxkqxb7tnulhlgstk6lb40qtpmx.lambda-url.ap-south-1.on.aws/", vari)
          if (response?.data?.status == 200) {
            setTryButton(false)
          } else {
            setTryButton(true)
          }
        }
      }

      if (surveyIdRef.current === 1765) {
        // console.log(results, 'results');
        const response = await InsertGogasReferralReg(results, client)
      }

      //CNG Marketing Leads
      if (surveyIdRef.current === 1845) {
        const res = await InsertCNGLeads(results)
      }

      if (results.coupon_code) {
        accID.current = sender.data?.account_id || 0;
        if (surveyIdRef.current === 1052 || surveyIdRef.current === 1215 || surveyIdRef.current === 1660 && !results?.wallet_user) {
          // console.log('inside if')
          results.survey_id = surveyIdRef.current
          const result = await gogasRedeemSubmit(results)
          // console.log(result, 'res');
          if (result?.data?.success) {
            setTryButton(false)
          } else {
            setTryButton(true)
          }
        } else {
          const result = await couponRedeemSubmit(accID.current);
        }
        //  console.log(result,'result')
      }
      if (surveyIdRef.current == 1211) {
        const response = await amkmJainismUserInsert(results)
        // console.log(response);
      }

      if (surveyIdRef.current == 1509) {
        const response = await gogasCoinAdding(results)
        // console.log(response);
        if (response?.data?.code == 200) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }
      if (surveyIdRef.current == 1511 || surveyIdRef.current == 1695 || surveyIdRef.current == 1805) {
        const response = await gogasCoinsRedeem(results)
        // console.log(response);
        if (response?.data?.code == 200) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }

      if (results?.api?.length > 0) {
        const response = await ApiFunction(results?.api, results)
        if (response?.data?.status == 200) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }
      if (surveyIdRef.current == 1574) {
        const response = await gogasCNGUsers(results, mtoken)
        // console.log(response);
      }

      if (surveyIdRef.current == 1672) {
        // console.log(results);
        const response = results?.gogas_user_id > 0 ? await UpdateLPGCards(results, client) :
          await getAPI("https://7y6uhmjtkhk5pmifo3othj6tgy0sjmur.lambda-url.ap-south-1.on.aws/", results);
        // console.log(response);
      }

      if (surveyIdRef.current == 1578) {
        const response = await gogasCNGWalletTrans(results, mtoken)
        if ((response?.state == "success")) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }
      // to send email on survey submit 
      // create field in the survey with name
      // sendEmail and let the default value be true
      if (results.sendEmail) {
        const sendMailResult = await getAPI("https://6tgvrplkxbg2bif6vrv5gxdofe0wrver.lambda-url.ap-south-1.on.aws/", results);
      }

      if (surveyIdRef?.current === 1671) {
        let userId = 0
        if (results?.user_id > 0) {
          userId = results?.user_id
        } else {
          const { data } = await InsertECUsers(results, client)
          userId = data?.insert_ec_users_one?.id
        }
        const resp = await UpdateECCards({ "qr_code": results?.qr_code, "user_id": userId }, client)
      }

      if (surveyIdRef.current === 1783) {
        const response = await getAPI("https://ul27kg46zpycfrdb6nodrhkcji0brtvp.lambda-url.ap-south-1.on.aws/", results);
        if (response?.data?.insert_cng_gogas_wallet_transactions_one) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }

      if (surveyIdRef.current === 1051 || surveyIdRef.current === 1552) {
        const vari = {
          "qr_id": null,
          "phone_number": phone,
          "name": name,
          "age_range": "0",
          "survey_id": surveyIdRef.current,
          "response_details": results
        }
        gogasResRef.current = vari
        // console.log(vari);

        const response = await getAPI("https://tk2reuxkqxb7tnulhlgstk6lb40qtpmx.lambda-url.ap-south-1.on.aws/", vari)
        if (response?.data?.status == 200) {
          setTryButton(false)
        } else {
          setTryButton(true)
        }
      }
      let sub = {};
      loadingRef.current = true;
      if (surveyIdRef.current === 1614 || surveyIdRef.current === 1680 || surveyIdRef.current === 1770) {
        console.log(results, "results")
        if (results.res_id > 0) {
          const res = await UpdateSurveyResponse(results, client)
        } else {
          sub = await submitAPI(
            phone,
            gender,
            name,
            email,
            dob,
            ageRange,
            results,
            metadataRef.current,
            surveyResponse,
            pincode,
            area, //areaCode
            results?.salesmobile
          );
        }
        // console.log(results, 'results', res);
      }

      if (surveyIdRef.current === 944 && !results.already_done) {
        // console.log('res', results)
        const response = await getAPI("https://7y6uhmjtkhk5pmifo3othj6tgy0sjmur.lambda-url.ap-south-1.on.aws/", results);
      }

      if (surveyIdRef.current === 1676 || surveyIdRef.current === 1696 || surveyIdRef.current === 1780 || surveyIdRef.current === 1815) {
        // console.log('res', results)
        if (surveyIdRef.current === 1780) {
          const { data: res } = await client.query(
            {
              query: GetSpacesQuery,
              variables: { name: `%${results.station_name}%` },
              context: {
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTY4MDI2MDk1NiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.idq3fyqbnemJdsq5IrAhBNc2P5iXic4w6TmRp7sRaxM`
                }
              }
            }
          )
          // console.log(res);
          results.erp_code = res?.spaces?.length > 0 && res?.spaces[0]?.details?.erp_code || ""
          results.city = res?.spaces?.length > 0 && res?.spaces[0]?.details?.city || ""
          results.state = res?.spaces?.length > 0 && res?.spaces[0]?.details?.state || ""
        }
        results.vehicle_file = results.user_type === "new lpg vehicle" && results?.vehicle_file?.length > 0 && results?.vehicle_file[0]?.content || ""
        const response = await getAPI("https://7y6uhmjtkhk5pmifo3othj6tgy0sjmur.lambda-url.ap-south-1.on.aws/", results);
      }

      if (surveyIdRef.current !== 1052 && surveyIdRef.current !== 1215 &&
        surveyIdRef.current !== 1051 && surveyIdRef.current !== 1552 && surveyIdRef.current !== 944 &&
        surveyIdRef.current !== 1680 && surveyIdRef.current !== 1770 &&
        surveyIdRef.current !== 1574 && surveyIdRef.current !== 1660 && surveyIdRef.current !== 1614 && surveyIdRef.current !== 1676 && surveyIdRef.current !== 1696 &&
        surveyIdRef.current !== 1780 && surveyIdRef.current !== 1815) {
        sub = await submitAPI(
          phone,
          gender,
          name,
          email,
          dob,
          ageRange,
          results,
          metadataRef.current,
          surveyResponse,
          pincode,
          area, //areaCode
          results?.salesmobile
        );
        console.log("HI")
      }
      // else {
      //   SetFormComplete(true);
      // }
      // creating the token for user without otp @texvalley
      // console.log(sub,'sub');
      const outputJson = sub?.output && JSON.parse(sub?.output);
      const userToken =
        (outputJson?.length > 0 && outputJson[0].body?.token) ||
        (outputJson?.length > 0 && outputJson[1]?.body?.token) ||
        "";
      const userID =
        (outputJson?.length > 0 && outputJson[0].body?.user?.id) ||
        (outputJson?.length > 0 && outputJson[1]?.body?.user?.id) ||
        "";
      // console.log(outputJson[1]?.body.user.id);
      //retriving existing userid &token from resposne @texvalley
      // const existingUserToken=outputJson[0]?.token
      // const existingUser_UserId=outputJson[0]?.user_id
      // console.log(sales_mob,'teste', !sales_mob);
      if (!token && !mtoken && !sales_mob) {
        localStorage.setItem("token", userToken);
        localStorage.setItem("user_id", userID);
        // ||existingUserToken
        // ||existingUser_UserId
      }
      // else if (token||mtoken){

      // }

      //pincode
      if (pincode) {
        // console.log(pincode);
        // console.log(area); //areaCode
        const location = await pincodeFetch(pincode, area);
        // console.log(location, "location");
        //  console.log(results,"Results Without LOC");
        //results=[...results,...res]
        results = { ...sender.data, location: location };
        // console.log(results, "Results with LOC");
      }

      //order create API
      if (results?.form_type === "purchase") {
        await order_create(results);
      }
      if (results?.form_type === "expo_purchase") {
        await expo_order_create(results);
      }

      //crm create API
      if (results?.type === "crm") {
        // console.log(results, 'results');
        CrmActivityCreate(results);
      }
      //product create
      else if (results?.type === "products") {
        create_product(results);
      } else if (results?.type === "gogas") {
        await send_coins(results);
      } else if (results?.type === "gogasAccount") {
        await gogasLocation(results);
      }
      //merchat_Create
      if (surveyIdRef.current === 149) {
        if (results.question1 === "Add a Branch") {
          //console.log(results.question1)
          //console.log(results)
          branch_Create(results);
        } else if (results.question1 === "Add New Merchant") {
          merchant_Create(results);
        } else if (results.question1 === "Add a Contact") {
          //console.log(results);
          contact_Create(results);
        }
      }
      //pincode
      sub = (sub?.output && JSON.parse(sub?.output)) || null;
      // console.log(sub[0], "sub");
      if (results.rating && googleRating.current !== "") {
        if (results.rating > 3) {
          window.location.href = googleRating.current || "";
        } else if (sub[0]?.alreadyDone) {
          SetAlreadyDone(true);
        } else {
          navigate("/home", {
            state: {
              couponNum: 2,
            },
          });
        }
      }
      if (sub?.length > 0 && sub[0]?.alreadyDone) {
        SetAlreadyDone(true);
        // console.log(sub?.body?.alreadyDone,'alreaady done')
      } else {
        SetFormComplete(true);
        // const couponCount = sub[1]?.body?.insert_user_coupons?.returning.length
        // onCouponsDone(couponCount, results?.rating)
      }
      if (sub?.hasOwnProperty("survey")) {
        SetFormComplete(true);
        survey2.doComplete();
      }
    }

    SetLoading(false);
    loadingRef.current = false;
    //  localStorage.removeItem("link");
    // survey2.doComplete();
    // formComplete.current++;
  }, []);


  const expo_order_create = async (formResponse) => {
    const CreateApiUserResult = await CreateApiUser(formResponse?.name, formResponse?.mobile)
    console.log(CreateApiUserResult, 'result 2561')
    const user_id = CreateApiUserResult?.data?.insert_apiuser?.returning[0]?.id || ""
    console.log(encode(user_id * 11111), "user_id", user_id)
    const variables = {
      amount: formResponse?.total_amount || 0,
      form_type: "expo_purchase",
      user_id: encode(user_id * 11111),
      discount_code: "",
      billing_address_id: "NULL",
      subTotal: formResponse?.subTotal || 0,
      product_items: "",
      order_status: formResponse?.order_status || "PAYMENT_SUCCESS",
      event_id: 5,
      payment_mode: formResponse?.payment_type || "",
      get_link: false,
      order_products: [{
        event_ticket_types: formResponse?.product_id || "",
        quantity: formResponse?.quantity || 1,
        form_details: {
          name: formResponse?.name || "",
          mobile: formResponse?.mobile || ""
        }
      }]
    };
    const url =
      "https://6fnj2elisycqxohwmyxsybjqwi0mdhdr.lambda-url.ap-south-1.on.aws/"; //extraa-events-expo-order-process

    const res = await getAPI(url, variables);

    const encoded = encode(res?.data?.user_id * 11111);
    const desc = `Your+order+number+${res?.data?.user_id}+of+amount+Rs.${variables?.amount}+has+been+placed+successfully`;

    return res;
  };



  const order_create = async (items) => {
    // console.log(items, "order create items");
    let variables;
    if (items?.product_id) {
      // console.log(true);
      variables = {
        amount: items?.total_amount || 0,
        name: items?.name || "",
        email: items?.email || "",
        phone_number: items?.mobile || "",
        pincode: items?.pincode || "",
        state: items?.order_status || "",
        quantity: items?.quantity || "",
        payment_mode: items?.payment_type || "",
        product_id: items?.product_id || 0,
        get_link: false,
      };
    } else {
      const keysWithProductId = Object.keys(items).filter((key) =>
        key.includes("product_id")
      );
      const product_id = keysWithProductId.map((x) => {
        const cleanedProductId = x.replace("product_id_", "");
        return {
          product_variant_id: cleanedProductId,
          quantity: items[`product_id_${cleanedProductId}`],
        };
      });
      variables = {
        amount: items?.total_amount || 0,
        name: items?.name || "",
        email: items?.email || "",
        phone_number: items?.mobile || "",
        pincode: items?.pincode || "",
        state: items?.order_status || "",
        payment_mode: items?.payment_type || "",
        orderProducts: product_id,
        get_link: false,
      };
      // console.log(false, product_id,'product')
    }
    const url =
      "https://iulp7q2dvlrtswa66xmwf62t240qqynx.lambda-url.ap-south-1.on.aws/";
    const res = await getAPI(url, variables);
    const encoded = encode(res?.data?.order_id * 11111);
    const desc = `Your+order+number+${res?.data?.order_id}+of+amount+Rs.${items?.total_amount || 0
      }+has+been+placed+successfully`;
    const product_name = res?.data?.product_name;
    const mailVariables = {
      order_id: res?.data?.order_id.toString(),
      email: items?.email,
      order_link: `https://deals.extraa.in/od/${encoded}`,
    };
    // const endPoint = 'https://backend.aisensy.com/campaign/t1/api/v2';
    // let templateParams = [];
    // templateParams.push(res?.data?.order_id.toString());
    // templateParams.push(encoded.toString())
    // const payload = {
    //   apiKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY2ZTgyMjI0NTk4YTRkMGI3MjMyNTJmNCIsIm5hbWUiOiJBc2VyYSBUZWNobm9sb2dpZXMgMzAwNSIsImFwcE5hbWUiOiJBaVNlbnN5IiwiY2xpZW50SWQiOiI2NmU4MjIxNTU5OGE0ZDBiNzIzMjUwYzUiLCJhY3RpdmVQbGFuIjoiQkFTSUNfTU9OVEhMWSIsImlhdCI6MTcyNjQ4OTEyNH0.NAG2sW-r7WEmtas5l4Lx8ilmkD_HOnxHqtP7QCkIyVM",
    //   campaignName: "deals_order_confirmation",
    //   destination: items?.mobile,
    //   userName: items?.name,
    //   templateParams
    // };
    // const whatsappResponse = await axios.post(endPoint, payload, {
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // });
    // console.log('WhatsApp Response:', whatsappResponse.data);
    // await axiosGet(
    //   `https://api.growaasan.com/api/sendPosCommunication?clietnId=100365&authKey=Q0ptUDJ1dTlzZFYrd0RMUFR6aU5OUT09&communicationType=2&waTemplateName=deals_confirmation&waTemplateLang=en&country_code=91&customerMobile=${items?.mobile}&varCount=3&var1=${res?.data?.order_id || ""}&var2=${product_name || ""}&var3=${encoded}`
    // );
    // await axiosGet(
    //   `https://api.growaasan.com/api/sendPosCommunication?varCount=1&var1=${res?.data?.order_id}&var2=${encoded}&clietnId=100365&authKey=Q0ptUDJ1dTlzZFYrd0RMUFR6aU5OUT09&communicationType=1&smsTemplateId=1707170558637253609&country_code=91&customerMobile=${items?.mobile}&varCount=2`
    // );
    // if (items?.email?.length > 0) {
    //   await getAPI(
    //     "https://6tgvrplkxbg2bif6vrv5gxdofe0wrver.lambda-url.ap-south-1.on.aws/",
    //     mailVariables
    //   );
    // }

  };

  useEffect(() => {
    const currentRoute = location.pathname;
    if (data && data.surveys[0] && data.surveys[0].form_details) {
      // console.log(data.surveys[0]?.m_login,'data');

      // SetBanner(data.surveys[0]?.banner);
      statusRef.current = data.surveys[0]?.allow_multiple_responses;
      SetCoupons(data.surveys[0].survey_coupons);
      couponsRef.current = data.surveys[0].survey_coupons;
      // console.log(data.surveys[0].survey_coupons);
      SetBanner(data.surveys[0]?.banner || data.surveys[0]?.merchant?.logo);
      if (data.surveys[0]?.banner || data.surveys[0]?.merchant?.logo) {
        survey2.title = "";
      }
      already_done.current =
        data?.surveys?.length > 0 && data?.surveys[0]?.allow_multiple_responses;
      // console.log(data.surveys[0]?.metadata, 'flag', data.surveys[0].id);
      googleRating.current = googleLink || "";
      metadataRef.current = data.surveys[0]?.metadata;
      msgTitleRef.current = data.surveys[0]?.message_title;
      msgRef.current = data.surveys[0]?.message;
      qrIdRef.current = data.surveys[0].qr_id || qrId;
      surveyIdRef.current = data.surveys[0].id;
      dataRef.current = {
        locations: qrLocation || "",
        randomCoupons: randomCoupons || "",
        industries: industries,
      };
      SetFormDetails(data.surveys[0]?.form_details);
      SetLoading(false);

      const formArr = data.surveys[0]?.form_details;
      const cleanArr =
        formArr &&
        formArr.pages?.map((i) => {
          return i.elements?.map((x) => {
            return { name: x.name };
          });
        });
      const finalArr = flattenArray(cleanArr || []);
      const findIndex = finalArr?.findIndex((x) => x?.name === "mobile");
      const currentDataParam = new URLSearchParams(window.location.search).get("data");
      const currentDecodedUser = currentDataParam ? decodeUserData(currentDataParam) : null;

      if (
        !token &&
        findIndex === -1 &&
        data &&
        data.surveys[0] &&
        !data.surveys[0].m_login &&
        !currentDecodedUser?.mobile &&
        !sales_mob
      ) {
        if (surveyIdRef.current === 18) {
          navigate("/signup", { state: { url: currentRoute } });
        } else if (token === "undefined") {
          navigate("/", { state: { url: currentRoute } });
        } else {
          navigate("/", { state: { url: currentRoute } });
        }
      }
      if (data && data.surveys[0] && data.surveys[0].m_login) {
        const mtoken = queryParams.get("token") || localStorage.getItem("mtoken");
        if (!mtoken && !sales_mob) {
          navigate(data.surveys[0].id == 1578 ? "/gogas-cng/login" : "/mlogin", { state: { url: currentRoute } });
        }
      }
      //   setBoxData(data.boxes[0]);
    } else if (token === "undefined") {
      navigate("/", { state: { url: currentRoute } });
    }
    // localStorage.setItem("link", googleLink);
  }, [surveyLoading, error, data]);
  //  preFillMethod @texvalley
  survey2.getValue("pre_fill_id") &&
    getFreeFillForm(
      survey2,
      client,
      token,
      survey2.getValue("pre_fill_id"),
      decode
    );
  // function flattenArray(nestedArray) {
  //   const flattened = [];

  //   function flatten(arr) {
  //     arr.forEach((item) => {
  //       if (Array.isArray(item)) {
  //         flatten(item);
  //       } else {
  //         flattened.push(item);
  //       }
  //     });
  //   }

  //   flatten(nestedArray);

  //   return flattened;
  // }

  // let fd = formDetails;
  loadingRef.current = false;
  // useEffect(() => {
  //   if (formComplete) {
  //     survey2.doComplete();
  //   }
  // }, [formComplete]);

  // ----------------- SET API VALUES // NOT PRODUCTION READY --------------------
  // survey2.setValue("name", "MY NAME");
  // survey2.setValue("mobile", "8056299487");
  // survey2.setValue("gender", "Item 1");
  // survey2.setValue("dob", "1994-08-23");
  // survey2.setValue("email", "email@email.com");

  // ---------------------------------------------------------
  survey2.showProgressBar = "top";

  // survey id and theme map
  const thememap = {
    1692: SaravanaTheme,
    1691: SaravanaTheme,
    1729: AMJTheme,
    1731: AMJTheme,
    1733: AMJTheme,
    1735: AMJTheme,
    1736: AMJTheme,
    1742: AMJTheme,
    1744: AMJTheme,
    1746: AMJTheme,
    1747: AMJTheme,
    1748: AMJTheme,
    1750: AMJTheme,
    1751: AMJTheme,
    1752: AMJTheme,
    1753: AMJTheme,
    1754: AMJTheme,
    1724: AMJTheme,
    1725: AMJTheme,
    1662: AMJTheme,
    1668: AMJTheme,
    1669: AMJTheme,
    1670: AMJTheme,
    1711: AMJTheme,
    1712: AMJTheme,
    1713: AMJTheme,
    1714: AMJTheme,
    1715: AMJTheme,
    1716: AMJTheme,
    1717: AMJTheme,
    1718: AMJTheme,
    1719: AMJTheme,
    1720: AMJTheme,
    1721: AMJTheme,
    1770: ExpoTheme,
    29: skodaTheme,
    31: skodaTheme,
    37: skodaTheme,
    66: rotatryTheme,
    193: lifecellTheme,
    176: blackOrchidTheme,
    154: blackOrchidTheme,
    433: zimsonTheme,
    ...Object.fromEntries(
      [
        477, 478, 498, 499, 548, 550, 552, 554, 556, 558, 560, 562, 564, 566,
        568, 570, 571, 573, 575, 577, 579581, 583, 585, 587, 589, 591, 593, 595,
        597, 599, 601, 603, 60, 607, 609, 611, 613, 615, 617, 619, 621, 623,
        625,
      ].map((key) => [key, saiBabaTheme])
    ),
  };

  if (!Serializer.findClass("states")) {
    ComponentCollection.Instance.add({
      name: "states",
      title: "State",
      // The actual question that will do the job
      questionJSON: {
        type: "dropdown",
        placeholder: "Select a State...",
        choices: state,
      },
    });
  }

  if (!Serializer.findClass("cities")) {
    ComponentCollection.Instance.add({
      name: "cities",
      title: "City",
      // The actual question that will do the job
      questionJSON: {
        type: "dropdown",
        placeholder: "Select a City...",
        choices: citiesInIndia,
      },
    });
  }

  if (!Serializer.findClass("industry")) {
    ComponentCollection.Instance.add({
      name: "industry",
      title: "Industry",
      // The actual question that will do the job
      questionJSON: {
        type: "dropdown",
        placeholder: "Select a Industry...",
        choices: industry,
      },
    });
  }

  if (!Serializer.findClass("department")) {
    ComponentCollection.Instance.add({
      name: "department",
      title: "Office Department",
      // The actual question that will do the job
      questionJSON: {
        type: "dropdown",
        placeholder: "Select a department...",
        choices: department,
      },
    });
  }

  if (!Serializer.findClass("designations")) {
    ComponentCollection.Instance.add({
      name: "designations",
      title: "Office Designations",
      // The actual question that will do the job
      questionJSON: {
        type: "dropdown",
        placeholder: "Select a designation...",
        choices: Designations,
      },
    });
  }
  //pincode
  if (!Serializer.findClass("pincode")) {
    ComponentCollection.Instance.add({
      name: "pincode",
      title: "pincode",
      // The actual question that will do the job
      questionJSON: {
        type: "text",
        name: "pincode",
        placeholder: "Enter Pincode",
        isRequired: "true",
        requiredErrorText: "Field cannot be empty",
        min: 99999,
        max: 999999,
        maxLength: 6,
        validators: [
          {
            type: "regex",
            text: "Enter Valid Pincode",
            regex: "^[0-9]{6}$",
          },
        ],
      },
    });
  }
  if (!Serializer.findClass("mobile")) {
    ComponentCollection.Instance.add({
      name: "Mobile",
      title: "Mobile Number",
      // The actual question that will do the job
      questionJSON: {
        name: "mobile",
        title: "title",
        type: "text",
        inputType: "tel",
        placeholder: "Enter Mobile Number...",
        isRequired: "true",
        requiredErrorText: "Field cannot be empty",
        maxLength: 10,
        validators: [
          {
            type: "regex",
            text: "Enter Valid Mobile Number",
            regex: "^[0-9]{10}$",
          },
        ],
      },
    });
  }
  if (!Serializer.findClass("otp")) {
    ComponentCollection.Instance.add({
      name: "otp",
      title: "otp",
      // The actual question that will do the job
      questionJSON: {
        name: "otp",
        title: "otp",
        type: "text",
        inputType: "tel",
        placeholder: "Enter OTP...",
        isRequired: "true",
        requiredErrorText: "Field cannot be empty",
        maxLength: 4,
        validators: [
          {
            type: "regex",
            text: "Enter Valid OTP",
            regex: "^[0-9]{4}$",
          },
        ],
      },
    });
  }

  const currentRoute = window.location.pathname;

  // const currentRoute = window.location.pathname;

  // console.log("Current Route:", currentRoute);

  // const dynamicManifest = generateDynamicManifest(currentRoute);

  // useEffect(() => {
  //   // Create a JSON blob of the manifest data
  //   const manifestBlob = new Blob([JSON.stringify(dynamicManifest)], {
  //     type: "application/json",
  //   });

  //   // Create a URL for the blob
  //   const manifestUrl = URL.createObjectURL(manifestBlob);

  //   // Set the dynamic manifest URL in the document head
  //   const link = document.createElement("link");
  //   link.setAttribute("rel", "manifest");
  //   link.setAttribute("href", manifestUrl);
  //   document.head.appendChild(link);

  //   return () => {
  //     // Clean up when the component is unmounted
  //     document.head.removeChild(link);
  //     URL.revokeObjectURL(manifestUrl);
  //  //   window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  //   };
  // }, [dynamicManifest]);

  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    // console.log('in use') // This should appear in the console
    const handleBeforeInstallPrompt = (event) => {
      // console.log('handler')
      event.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(event);
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const onClick = (e) => {
    if (promptInstall) {
      // Show the browser's installation prompt
      promptInstall.prompt();

      // Wait for the user's choice
      promptInstall.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the installation");
        } else {
          console.log("User declined the installation");
        }

        // Reset the deferredPrompt variable
        promptInstall = null;
      });
      setSupportsPWA(false);
    }
  };

  const onLogoutClick = () => {
    // console.log('clicked');
    localStorage.clear();
    window.location.reload();
  };

  let count = 1
  const onRetryClick = async () => {
    if (surveyIdRef.current === 1509) {
      const response = await gogasCoinAdding(gogasResRef.current)
      if (response?.data?.code == 200) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    }
    else if (surveyIdRef.current === 1511 || surveyIdRef.current === 1695 || surveyIdRef.current === 1805) {
      const response = await gogasCoinsRedeem(gogasResRef.current)
      if (response?.data?.code == 200) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    } else if (surveyIdRef.current === 1051 || surveyIdRef.current === 1552) {
      const response = await getAPI("https://tk2reuxkqxb7tnulhlgstk6lb40qtpmx.lambda-url.ap-south-1.on.aws/", gogasResRef.current)
      if (response?.data?.status == 200) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    } else if (surveyIdRef.current == 1578) {
      const response = await gogasCNGWalletTrans(gogasResRef.current, mtoken)
      if (response?.state == "success") {
        setTryButton(false)
      } else {
        if (count > 6) {
          setInterval(async () => await onRetryClick(), 5000)
        } else {
          setTryButton(true)
        }
      }
    } else if (gogasResRef?.current?.api?.length > 0) {
      const res = await ApiFunction(gogasResRef?.current?.api, gogasResRef?.current)
      if (res?.data?.status == 200) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    } else if (surveyIdRef.current === 1783) {
      const response = await getAPI("https://ul27kg46zpycfrdb6nodrhkcji0brtvp.lambda-url.ap-south-1.on.aws/", gogasResRef.current);
      if (response?.data?.insert_cng_gogas_wallet_transactions_one) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    }
    else {
      const result = await gogasRedeemSubmit(gogasResRef.current)
      // console.log(result, 'res');
      if (result?.data?.success) {
        setTryButton(false)
      } else {
        setTryButton(true)
      }
    }
  }

  return (
    <div
      className="csv-survey"
      style={thememap[surveyIdRef.current] || defaultTheme}
    >
      {/* <SurveyComponent /> */}
      {/* {data?.surveys?.length > 0 && data?.surveys[0]?.m_login && */}
      <div className={banner ? "logout" : "without_banner"}>
        <div className="box-2" onClick={onLogoutClick}>
          <div className="btn btn-two">
            <LogoutIcon />
            <p>log out</p>
          </div>
        </div>
      </div>
      {banner && (
        <>
          <div style={{ width: "100%" }}>
            <Stack
              alignItems="center"
              style={{ width: "100%", background: "var(--banner-bg)" }}
            >
              <Box maxWidth="600px" width="100%">
                <img
                  style={{
                    width: "100%",
                    maxHeight: 300,
                    objectFit: "contain",
                  }}
                  src={banner}
                  alt=""
                />
              </Box>
            </Stack>
          </div>
        </>
      )}
      {formDetails &&
        !loading &&
        survey2 &&
        !alreadyDone &&
        !formComplete &&
        !loadingRef.current && (
          <>
            <Survey
              model={survey2}
              showCompletedPage={false}
              onComplete={submitSurvey}
            />
            {(currentRoute === "/csv/test_survey_state_survey" ||
              currentRoute === "/csv/pothys_test_survey") &&
              supportsPWA && (
                <div className="installDiv">
                  <CloseIcon
                    fontSize="small"
                    onClick={() => setSupportsPWA(false)}
                  />
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontFamily: "rota-black",
                        marginRight: 2,
                      }}
                    >
                      Get our app for a better experience
                    </Typography>
                    <button className="insBtn" onClick={(e) => onClick(e)}>
                      Install Now
                    </button>
                  </Stack>
                </div>
              )}
          </>
        )}
      {(loading || loadingRef.current) && (
        <Fade in>
          <div
            style={{
              width: "100%",
              height: "90vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // background: "#FFF7DF",
              background: "#faf9f7"
            }}
          >
            <CircularProgress />
          </div>
        </Fade>
      )}
      {alreadyDone &&
        !statusRef.current &&
        (surveyIdRef.current === 29 ||
          surveyIdRef.current === 31 ||
          surveyIdRef.current === 37 ? (
          <ComeBackLater
            msg={"Looks like you've already done this..."}
            nofooter={true}
            thankMsg={"Thank you for your registration"}
            survey_id={surveyIdRef.current}
          />
        ) : (
          surveyIdRef.current !== 65 && (
            <>
              <ComeBackLater
                msg={"Looks like you've already done this..."}
                nofooter={true}
                thankMsg={"Thank you, we will get back to you soon"}
              />
              {/* {console.log("already done")} */}
            </>
          )
        ))}
      {formComplete && !tryButton &&
        !alreadyDone &&
        surveyIdRef.current !== 65 &&
         surveyIdRef.current !== 1848 &&
        !statusRef.current && (
          <>
            <ThankYouPage
              title={msgTitleRef.current}
              message={msgRef.current}
              coupons={coupons}
              sales_mob={sales_mob}
            />
          </>
        )}
      {(formComplete && surveyIdRef.current === 65) ||
        (formComplete && statusRef.current && !tryButton && surveyIdRef.current !== 1848 &&(
          <>
            <ThankYouPage
              title={msgTitleRef.current}
              message={msgRef.current}
              coupons={coupons}
              sales_mob={sales_mob}
            />
          </>
        ))}
      {surveyIdRef.current === 65 && formComplete && !tryButton && (
        <ThankYouPage
          title={msgTitleRef.current}
          message={msgRef.current}
          coupons={coupons}
          sales_mob={sales_mob}
        />
      )}
       {formComplete &&
        !tryButton &&
        !alreadyDone &&
        surveyIdRef.current === 1848 && (
          <ContestThankYou isWinner={resultTrue} />
        )}
      {tryButton &&
        <div style={{
          width: "100%",
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: 'column'
        }}>
          <h2>Something went wrong. Please retry to submit the coupon</h2>
          <Button variant="contained" sx={{ marginTop: 2 }} onClick={onRetryClick}>Retry</Button>
        </div>
      }
      {/* {formComplete && !alreadyDone && (
        <>
          <Fade in>
            <div
              style={{
                width: "100%",
                height: "90vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          </Fade>
        </>
      )} */}
      <div
        className="powered"
        style={{
          marginBottom: 0,
          paddingBottom: "12px",
          paddingTop: "12px",
        }}
      >
        Forms by 
        <img src="../assets/extraa_logo.png" alt="" />
      </div>
    </div>
  );
}

export default CustomSurvey;
